export const zh = {
  common: {
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    close: '关闭',
    loading: '加载中...',
    success: '成功',
    error: '错误',
    retry: '重试',
  },
  app: {
    Home: '首页',
    Create: '创建',
    Projects: '项目',
    Templates: '模板',
    LivePreview: '实时预览',
    Resource: '资源',
    Assets: '素材',
    Tool: '工具',
    AllTools: '所有工具',
    Settings: '设置',
    logout: '退出登录',
    Feedback: '反馈',
    Support: '支持',
    profile: '个人主页',
    accountSettings: '账户设置',
    Workspace: '工作空间',
    RedemptionCode: '兑换码',
    generationHistory: '生成历史',
    privacy: '隐私政策',
    terms: '服务条款',
    invite: '邀请好友',
    getMoreCredits: '获取更多积分',
    creditsRemaining: '积分剩余：',
    upgrade: '升级',
    clickToAccess: '点击访问',
    account: '账户',
    claimFreeCredits: '领取免费积分',
    claimed: '已领取',
  },
  dailyCredits: {
    success: {
      title: '成功',
      description: '每日积分领取成功！',
    },
    error: {
      title: '错误',
      description: '领取积分失败',
    },
  },
  design: {
    styleBrush: '样式刷',
    clear: '清空',
    fill: '填充颜色',
    background: '背景',
    group: '组合图层',
    Ungroup: '解除组合',
    replace: '替换图片',
    generateImage: 'AI 生成图片',
    removeBackground: '移除图片背景',
    generate: 'AI 生成',
    editImage: '编辑',
    imageSearch: '搜索图片',
    rembg: '移除背景',
    processing: '处理中...',
    replaceImage: '替换图片',
    recents: '最近使用',
    assets: '素材库',
    qrcode: '二维码',
    icon: '图标',
    uploadImage: '上传图片',
    variableLabel: '变量标签',
    textSettings: '文字设置',
    letterSpacing: '字间距',
    lineHeight: '行高',
    groupSettings: '组合设置',
    lineSettings: '线段设置',
    children: '子节点',
    mixedNode: '属性设置',
    opacity: '透明度',
    radius: '圆角',
    rotation: '旋转',
    border: '边框',
    position: '位置和尺寸',
    dimensions: '尺寸',
    shadow: '阴影',
    password: {
      title: '需要密码',
      description: '此项目受密码保护。请输入密码以访问。',
      placeholder: '输入密码',
      submit: '提交',
      cancel: '取消',
      invalidPassword: '密码错误',
    },
    leave: {
      generating: '项目正在生成中。离开可能会中断生成过程。确定要离开吗？',
      unsaved: '您有未保存的更改。确定要离开吗？',
    },
    shadowPanel: {
      color: '颜色',
      parameters: '参数',
      presets: '预设',
      none: '未设置',
      blur: '模糊',
      spread: '扩散',
    },
    imageFitPanel: {
      objectFit: '图片填充模式',
      mixed: '混合',
      cover: '覆盖',
      contain: '包含',
      fill: '填充',
      none: '无',
      scaleDown: '按比例缩小',
      desc: {
        cover: '缩放填充，可能裁剪',
        contain: '缩放完全适应',
        fill: '拉伸完全填充',
        none: '原始尺寸，不缩放',
        scaleDown: '如果较大则按比例缩小',
      },
    },
    export: '导出图片',
    framePresetPanel: {
      presets: '预设',
      colorPresets: '颜色预设',
      imagePresets: '图片预设',
      texture: '纹理',
      abstract: '抽象',
      showLess: '显示更少',
      showMore: '显示更多',
    },
    framePanel: {
      pageSettings: '页面设置',
      presets: '预设',
      effects: '效果',
      colorPresets: '颜色预设',
      imagePresets: '图片预设',
      texture: '纹理',
      abstract: '抽象',
      noise: '噪点',
      blur: '模糊',
    },
    flipPanel: {
      flip: '翻转',
      horizontal: '水平',
      vertical: '垂直',
      flipHorizontal: '水平翻转',
      flipVertical: '垂直翻转',
    },
    rotatePanel: {
      rotate: '旋转',
      rotation: '旋转角度',
      rotate90: '旋转 90°',
    },
    backdropFilter: '背景滤镜',
    backdropPanel: {
      none: '未设置',
      'grayscale(100%)': '灰度',
      'sepia(100%)': '棕褐色',
      'blur(5px)': '模糊',
      'brightness(150%)': '亮度',
      'contrast(150%)': '对比度',
      'invert(100%)': '反色',
      'saturate(200%)': '饱和度',
    },
    dashPanel: {
      lineStyle: '线条样式',
      style: '样式',
      solid: '实线',
      dashed: '虚线',
      dotted: '点线',
      dashDot: '点划线',
      dashDotDot: '双点划线',
      custom: '自定义',
      mixed: '混合',
      customPattern: '自定义图案',
      example: '例如: 5,5',
    },
    lineSize: {
      lineThickness: '线条粗细',
    },
    lineStylePanel: {
      lineCap: '线端样式',
      lineJoin: '线条连接',
      butt: '平端',
      round: '圆端',
      square: '方端',
      miter: '尖角',
      bevel: '斜角',
    },
    Custom: '自定义',
    Presets: '预设',
    textStyle: '文字样式',
    fontFamily: '字体',
    fontSize: '文字大小',
    fontWeight: '字重',
    textAlignment: '文字对齐',
    highlight: '高亮',
    stroke: '描边',
    effect: '特效',
    padding: {
      padding: '内边距',
      top: '上',
      bottom: '下',
      left: '左',
      right: '右',
    },
    save: '保存',
    size: '尺寸',
    color: '颜色',
    font: {
      allFonts: '所有字体',
      Chinese: '中文字体',
      English: '英文字体',
      fontStyles: '字体样式',
      language: '语言',
      searchFonts: '搜索字体...',
    },
    imageSettings: '图片设置',
    imageSource: '图片来源',
    objectFit: '适应方式',
    imageEditing: '图片编辑',
    backgroundRemoval: '背景移除',
    imageUpscale: '图像放大',
    enhanceImageQuality: '提升图像质量和分辨率',
    crop: '裁剪',
    bgRemover: '移除背景',
    cropDescription: '调整大小和重新构图',
    removeObjects: '移除对象',
    imageInpaint: '涂抹覆盖不需要的对象',
    advancedSettings: '高级设置',
    clipPath: '裁剪路径',
    pageSettings: '页面设置',
    solid: '纯色',
    gradient: '渐变',
    image: '图片',
    presets: '预设',
    effects: '效果',
    decoration: '装饰',
    spacing: '间距',
    clearEffects: '清空效果',
    highlightTip: '提示：请先选择文本内容，然后点击应用高亮效果',
    noise: '噪点',
    blur: '模糊',
    overlay: '叠加层',
    overlayColor: '叠加颜色',
    overlayOpacity: '叠加透明度',
    filter: '滤镜',
    filterIntensity: '滤镜强度',
    imageStyle: '图片风格',
    glassLight: '玻璃光效',
    default: '默认',
    glassBlack: '黑色玻璃',
    outline: '轮廓',
    textEffect: '文字效果',
    textHighlight: '文字高亮',
    applyHighlight: '应用高亮',
    highlightColor: '高亮颜色',
    highlightStyle: '高亮样式',
    highlightOpacity: '高亮透明度',
    textDecoration: '文字装饰',
    underline: '下划线',
    strikethrough: '删除线',
    italic: '斜体',
    bold: '粗体',
    shape: '图形',
    moreOptions: '更多',
    shadowOptions: '阴影选项',
    shadowNone: '无',
    shadowSmall: '小',
    shadowMedium: '中',
    shadowLarge: '大',
    shadowXLarge: '特大',
    shadowInner: '内阴影',
    shadowSoft: '柔和',
    shadowHard: '硬朗',
    shadowOffset: '偏移',
    shadowSpread: '扩散',
    customShadow: '自定义阴影',
    // 图片滤镜
    filters: {
      Binarize: '二值化',
      Brightness: '亮度',
      Gamma: '伽马',
      Sharpen: '锐化',
      Solarize: '曝光',
      GrayScale: '灰度',
      GaussianBlur: '高斯模糊',
    },

    // 阴影选项
    shadowCustom: '自定义',
    shadowColor: '阴影颜色',
    shadowBlur: '阴影模糊',
    shadowDistance: '阴影距离',
    shadowAngle: '阴影角度',

    // 图片风格
    imageStyleDefault: '默认',
    imageStyleGlassLight: '玻璃光效',
    imageStyleGlassBlack: '黑色玻璃',
    imageStyleOutline: '轮廓',

    // 滤镜效果
    filterNone: '无',
    filterVintage: '复古',
    filterSepia: '棕褐色',
    filterDramatic: '戏剧性',
    filterSharp: '锐化',
    filterCool: '冷色调',
    filterWarm: '暖色调',
    tools: {
      undo: '撤销操作',
      redo: '恢复操作',
      showPages: '展示页面列表',
      zoomToFit: '缩放至合适大小',
      zoomIn: '放大',
      zoomOut: '缩小',
      handTool: '移动',
      selectionMode: '选择',
      defaultSelectionMode: '选择',
      deepSelectionMode: '深度选择',
      addText: '添加文字',
      addImage: '添加图片',
      addRectangle: '添加矩形',
      addCircle: '添加圆形',
      addIcon: '添加图标',
      addQRCode: '添加二维码',
      text: '文字',
      image: '图片',
      shape: '形状',
      rectangle: '矩形',
      circle: '圆形',
      icon: '图标',
      qrCode: '二维码',
      dragAndDrop: '拖放到画布',
      clickToAdd: '点击添加',
    },
    inserts: {
      rectangle: '矩形',
      circle: '圆形',
      triangle: '三角形',
      star: '星形',
      line: '线条',
      image: '图片',
      icon: '图标',
      qrcode: '二维码',
      heading1: '标题 1',
      heading2: '标题 2',
      bodyText: '正文',
      quote: '引用',
      upload: '上传',
      or: '或',
      imageUrl: '图片链接',
      imageUrlPlaceholder: 'https://example.com/image.jpg',
      add: '添加',
    },
    publish: {
      share: '分享',
      publish: '发布',
      title: '分享设计',
      publishDescription: '分享你的设计到社区',
      selectPage: '选择页面',
      choosePage: '选择要导出的页面',
      page: '页面',
      name: '名称',
      description: '描述',
      tags: '标签',
      tagPlaceholder: '输入标签',
      update: '更新',
      uploading: '上传中...',
      success: {
        title: '模板分享成功',
        description: '您的模板已发布到社区画廊',
      },
      error: {
        title: '无法分享模板',
        description: '出现错误。请检查网络连接后重试。',
      },
      projectPermissions: '访问权限',
      publishTemplate: '发布模板',
      visibility: '项目可见性',
      public: '公开',
      publicDescription: '任何人都可以在社区画廊中查看此项目',
      private: '私密',
      privateDescription: '只有您和您分享的人可以访问此项目',
      updating: '更新中...',
      updatePermissions: '更新权限',
      shareLink: '分享链接',
      copyLink: '复制链接',
      linkCopied: '链接已复制到剪贴板！',
      embedCode: '嵌入代码',
      copyCode: '复制代码',
      codeCopied: '代码已复制到剪贴板！',
      shareUrl: '分享链接',
      shareUrlPublicDesc: '任何人都可以通过此链接查看您的项目',
      shareUrlPrivateDesc: '只有您可以通过此链接访问此项目',
      publicAccess: '公开访问',
      privateAccess: '私人访问',
      urlWillAppearHere: '链接将显示在这里',
      urlReady: '链接已准备就绪',
      urlNotReady: '链接不可用',
      copy: '复制',
      copySuccess: '已复制！',
      copySuccessDesc: '分享链接已复制到剪贴板',
      copyFailed: '复制失败',
      copyFailedDesc: '无法将链接复制到剪贴板',
      accessLevel: '访问级别',
      anyoneWithLink: '任何拥有链接的人',
      canView: '可以查看',
      accessPassword: '访问密码',
      accessPasswordPlaceholder: '设置访问密码(可选)',
      accessPasswordDesc: '访客需要此密码才能查看您的项目',
    },
    blendPanel: {
      blendMode: '混合模式',
      mixed: '混合',
      normal: '默认',
      multiply: '正片叠底',
      screen: '滤色',
      overlay: '叠加',
      darken: '变暗',
      lighten: '变亮',
      colorDodge: '颜色减淡',
      colorBurn: '颜色加深',
      hardLight: '强光',
      softLight: '柔光',
      difference: '差值',
      exclusion: '排除',
      hue: '色相',
      saturation: '饱和度',
      color: '颜色',
      luminosity: '明度',
      desc: {
        normal: '无混合，默认模式。',
        multiply: '通过将基色与混合色相乘使颜色变暗。',
        screen: '通过反相、相乘再反相使颜色变亮。',
        overlay: '结合正片叠底和滤色，增强对比。',
        darken: '保留较暗的颜色。',
        lighten: '保留较亮的颜色。',
        colorDodge: '提亮基色以反映混合色。',
        colorBurn: '加深基色以反映混合色。',
        hardLight: '根据混合色结合正片叠底和滤色。',
        softLight: '柔和的光照效果。',
        difference: '从较亮的颜色中减去较暗的颜色。',
        exclusion: '类似差值但对比度较低。',
        hue: '使用混合色的色相。',
        saturation: '使用混合色的饱和度。',
        color: '使用混合色的颜色。',
        luminosity: '使用混合色的明度。',
      },
    },
    textAlignPanel: {
      textAlignment: '文本对齐',
      horizontalAlignment: '水平对齐',
      verticalAlignment: '垂直对齐',
      alignLeft: '左对齐',
      alignCenter: '居中对齐',
      alignRight: '右对齐',
      alignJustify: '两端对齐',
      alignTop: '顶部对齐',
      alignMiddle: '居中对齐',
      alignBottom: '底部对齐',
    },
    maskPanel: {
      mask: '遮罩',
      mixed: '混合',
      none: '无',
      alphaClip: '透明度遮罩 - 裁剪',
      alphaIntersect: '透明度遮罩 - 相交',
      desc: {
        none: '未应用遮罩。',
        alphaClip: '使用透明通道裁剪内容。',
        alphaIntersect: '使用透明通道与内容相交。',
      },
    },
    skewPanel: {
      skew: '斜切',
      parameters: '参数',
      presets: '预设',
      none: '无',
      mixed: '混合',
      x: 'X 轴斜切',
      y: 'Y 轴斜切',
      preview: '预览',
      applyPreset: '应用预设',
      reset: '重置',
      custom: '自定义',
      preset: '预设',
      // 预设名称（应与 SKEW_PRESETS 键一致）
      skewPreset: {
        none: '无',
        italic: '斜体',
        'slight-left': '微左斜',
        'slight-right': '微右斜',
        'slight-up': '微上斜',
        'slight-down': '微下斜',
        'diagonal-left': '左上斜',
        'diagonal-right': '右下斜',
        'extreme-left': '极左斜',
        'extreme-right': '极右斜',
        'perspective-left': '左透视',
        'perspective-right': '右透视',
        custom: '自定义',
      },
      // 预设描述（用于提示或无障碍）
      skewPresetDesc: {
        none: '未应用斜切。',
        italic: '经典斜体风格斜切。',
        'slight-left': '轻微向左斜切。',
        'slight-right': '轻微向右斜切。',
        'slight-up': '轻微向上斜切。',
        'slight-down': '轻微向下斜切。',
        'diagonal-left': '左上方向的对角斜切。',
        'diagonal-right': '右下方向的对角斜切。',
        'extreme-left': '强烈向左斜切。',
        'extreme-right': '强烈向右斜切。',
        'perspective-left': '左侧透视斜切。',
        'perspective-right': '右侧透视斜切。',
        custom: '自定义斜切数值。',
      },
      // UI 标签和提示
      selectPreset: '选择预设',
      selected: '已选',
      setCustom: '设置自定义斜切值',
      resetToNone: '重置为无斜切',
      current: '当前',
      skewPreview: '斜切预览',
      skewXLabel: '水平斜切（X 轴）',
      skewYLabel: '垂直斜切（Y 轴）',
      skewXDesc: '调整水平斜切角度。',
      skewYDesc: '调整垂直斜切角度。',
      parametersTab: '调整斜切参数',
      presetsTab: '选择预设样式',
    },
  },
  actions: {
    Undo: '撤销',
    Redo: '重做',
    Copy: '复制',
    Duplicate: '复制副本',
    Paste: '粘贴',
    Cut: '剪切',
    Delete: '删除',
    Layer: '图层',
    Alignment: '对齐',
    SelectLayer: '选择图层',
    CopyAs: '复制为',
    CopyasPNG: '复制为 PNG',
    CopyasWebp: '复制为 Webp',
    CopyasHTML: '复制为 HTML',
    CopyAsRawHTML: '复制为内联 HTML',
    ImageCrop: '裁剪图片',
    Forward: '上移一层',
    Backward: '下移一层',
    BringToFront: '置于顶层',
    SendToBack: '置于底层',
    alignToPageTop: '对齐页面顶部',
    alignToPageLeft: '对齐页面左侧',
    alignToPageMiddle: '对齐页面中部',
    alignToPageCenter: '对齐页面中心',
    alignToPageBottom: '对齐页面底部',
    alignToPageRight: '对齐页面右侧',
    alignToTop: '顶部对齐',
    alignToBottom: '底部对齐',
    alignToMiddle: '中部对齐',
    alignToCenter: '中心对齐',
    alignToLeft: '左侧对齐',
    alignToRight: '右侧对齐',
    AddToLibrary: '添加到素材库',
    CopyTextStyle: '复制样式',
    PasteTextStyle: '粘贴样式',
    Advanced: '高级',
    selectAll: '全选',
    SplitFrameSections: '拆分画板',
    MergeFrames: '合并画板',
    flipHorizontal: '水平翻转',
    flipVertical: '垂直翻转',
    Distribute: '分布',
    DistributeHorizontal: '水平分布',
    DistributeVertical: '垂直分布',
    EqualSpacingHorizontal: '水平等间距',
    EqualSpacingVertical: '垂直等间距',
  },
  landing: {
    seoTitle: 'Seede AI - 想法一闪，设计即成。',
    seoDescription:
      '输入文案秒变专业设计！Seede ai 设计工具一键生成社交媒体海报/营销素材，无需下载安装，1 分钟上手创作您的第一份设计作品。',
    seoKeywords:
      'seede, seede ai, AI设计工具, 智能海报生成器,零基础设计软件,微信朋友圈模板生成,电商主图智能制作',
    featuresSubtitle: '强大的功能',
    featuresDescription:
      'Seede ai 提供了一套强大的 AI 驱动工具,可以简化您的设计工作流程,并帮助您轻松创建出色的视觉效果。',
    recommendations: '推荐内容',
    refresh: '刷新',
    productFeatures: '产品功能',
    signIn: '登录',
    signUp: '注册',
    useCases: '使用案例',
    pricing: '定价',
    products: '产品',
    features: '功能',
    templates: '模板中心',
    tryForFree: '免费试用',
    getStarted: '立即开始',
    heroTitle: `<span style="display: inline-block; margin-left: 1rem;">想法一闪，设计即成。</span>`,
    heroSubtitle: 'Seede AI 助您创意变为现实，让设计变得简单而优雅。',
    learnMore: '了解更多',
    richTemplates: '丰富的 AI 创意模板',
    whyNotTry: '何不试一试？',
    browserAllTemplates: '浏览所有模板',
    startUsing: '开始使用',
    whatIsSeede: 'Seede AI 是什么？',
    whatIsSeedeDesc: `Seede AI 是一款 AI 驱动的设计工具，只需一分钟即可帮助您创建出色的视觉效果，无需任何设计技能。完美适用于社交媒体内容、营销材料和创意项目。`,
    mainFeatures: '核心功能',
    createWithAI: '用 Seede AI 创作，时刻自由。',
    creationFromCommunity: '来自社区的创作',
    creatorCount: 'Seede AI - 人人都能一键做出专业设计与排版。',
    coreFeaturesBadge: '核心功能',
    coreFeature1: '内容优先，完整保留你的文字与结构',
    coreFeature1Desc: '输入的文字、段落和结构都会被「完整保留」，并通过更具设计感的方式呈现。',
    coreFeature2: '随心编辑，灵活修改文字和替换图片',
    coreFeature2Desc:
      '一键生成精美设计后，文字和图片都可以自由替换、调整、编辑或删除，创作完全由你掌控。',
    coreFeature3: '文字准确，精确呈现全球语言与格式',
    coreFeature3Desc:
      '支持 100+ 语言和各种文档格式，一键转换，输出精准无乱码，全球跨境图文轻松设计。',
    freeTools: '图片处理工具',
    ctaTitle: '立即体验 AI 智能设计',
    ctaNow: '立即免费试用 Seede AI.',
    ctaDesc: '输入任何内容，Seede AI 帮你生成意图精准和结构合理的专业设计。',
    startCreating: '开始创作',
    footerDesc:
      'Seede AI - AI 驱动的设计工具，让创意工作变得简单、快速、有趣 | 使用 Seede AI 立即创建专业设计',
    product: '产品',
    cases: '使用案例',
    resources: '资源',
    helpCenter: '帮助中心',
    docs: '文档',
    affiliates: '联盟计划',
    company: '公司',
    legal: '法律条款',
    team: '团队',
    aboutUs: '关于',
    blog: '博客',
    contactUs: '联系我们',
    dashboard: '项目列表',
    socialProof: '{{user}} 创作者正在使用 Seede 进行设计',
    howItWorks: '如何使用 ？',
    howYouCanDesign: '如何像专业人士一样设计',
    createInFourSteps: '通过四个简单步骤创建精美设计',
    steps: {
      step1Title: '描述',
      step1Desc: '描述您想要设计的内容。',
      step2Title: '创建',
      step2Desc: 'Seede 创建您的第一个版本。',
      step3Title: '改进',
      step3Desc: '通过提出修改建议来改进设计。',
      step4Title: '导出',
      step4Desc: '导出您的设计并发布或打印。',
    },
    designSteps: {
      idea: {
        title: '只需一个想法',
        desc: '从脑海中的任何想法开始。无论大小。',
      },
      generate: {
        title: '生成',
        desc: '输入您的想法，点击生成按钮即可',
      },
      seconds: {
        title: '只需几秒钟',
        desc: '等待几秒钟，奇迹发生，您就能获得专业级设计。',
      },
      export: {
        title: '改进或导出',
        desc: '与 Seede AI 边聊边思考，或直接导出使用。',
      },
    },
    // 新增翻译
    featureDesc: 'AI 驱动的专业设计生成工具',
    featuresIntroStrong: 'Seede AI 是一款 AI 设计工具',
    featuresIntroLight:
      '，可以帮助您在几秒钟内创建令人惊艳的视觉效果。无需设计技能。非常适合社交媒体内容、营销材料和创意项目。',
    feature1: '一分钟内 <br/> 完成设计',
    feature1Desc: '无需设计经验，1 分钟内为任何行业创建营销设计',
    feature2: '从图像和文档 <br/> 直接生成设计',
    feature2Desc: '直接上传图像或文档，AI即刻生成设计',
    feature3: 'AI 随时随地辅助你创作',
    feature3Desc: '通过分层编辑生成元素，AI辅助局部优化',
    tool1: '横屏转竖屏视频工具',
    tool1Desc: '将横屏视频转换为社交媒体适用的竖屏格式',
    tool2: '图片去背景',
    tool2Desc: '一键去除背景，保留主体',
    tool3: '魔术橡皮擦',
    tool3Desc: '轻松擦除不需要的元素',
    tool4: '图片生成',
    tool4Desc: '根据文字生成图片',
    tool5: '图片高清放大',
    tool5Desc: '提升图片分辨率',
    designs: '设计',
    promptsLibrary: '提示词库',
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
    community: '社区',
    connect: '联系我们',
    wechat: '微信用户群',
  },
  products: {
    posterGenerator: {
      title: '活动海报生成器',
      name: '活动海报',
      description: '快速创建专业的活动海报',
    },
    invitationGenerator: {
      title: '邀请函生成器',
      name: '邀请函',
      description: '创建精美的数字邀请函',
    },
    infographicGenerator: {
      title: '知识卡片生成器',
      name: '知识卡片',
      description: '创建视觉吸引力强的数据驱动型知识卡片',
    },
    newsletterGenerator: {
      title: '新闻简报图生成器',
      name: '信息简报',
      description: '创建专业的新闻简报图文',
    },
    flashcardGenerator: {
      title: '单词闪卡生成器',
      name: '单词闪卡',
      description: '生成学习用闪卡',
    },
    socialMediaGenerator: {
      title: '社交媒体图文生成器',
      name: '社交媒体图文',
      description: '使用 AI 创建吸引人的社交媒体内容',
    },
    wechatCoverGenerator: {
      title: '微信公众号封面生成器',
      name: '微信公众号封面',
      description: '使用 AI 创建吸引眼球的微信文章封面',
    },
    eventPromotionGenerator: {
      title: '活动推广海报生成器',
      name: '活动推广',
      description: '设计醒目的活动推广和广告',
    },
    albumCoverGenerator: {
      title: '专辑封面生成器',
      name: '专辑封面',
      description: '使用 AI 设计精美的音乐专辑封面',
    },
    signageGenerator: {
      title: '标识牌生成器',
      name: '标识牌',
      description: '创建专业的标识牌和展示材料',
    },
    menuGenerator: {
      title: '餐饮菜单生成器',
      name: '餐饮菜单',
      description: '使用 AI 创建视觉吸引力强的餐饮菜单',
    },
    flyerGenerator: {
      title: '传单生成器',
      name: '传单',
      description:
        '无论是寻找丢失宠物、画廊开幕还是筹款活动，都可以使用我们简单易用的工具创建精美传单',
    },
    scrollytellingGenerator: {
      title: '长图战报生成器',
      name: '长图',
      description:
        '创建视觉吸引力强的长图内容，完美呈现数据故事和精彩瞬间，让您的社交媒体分享更具吸引力',
    },
    multiPageBrochureGenerator: {
      title: '多页宣传册生成器',
      name: '多页宣传册',
      description: '使用 Seede AI 创建专业的多页宣传册',
    },
    presentationGenerator: {
      title: 'PPT 演示生成器',
      name: 'PPT',
      description: '使用 AI 驱动的设计创建专业的演示文稿幻灯片',
    },
    diagramGenerator: {
      title: '流程图生成器',
      name: '流程图',
      description: '使用 AI 驱动的设计创建专业的流程图',
    },
    pullUpBanner: {
      title: 'AI 易拉宝生成器',
      name: '易拉宝',
      description: '使用 AI 创建专业的易拉宝和立式展示架',
    },
  },
  library: {
    title: '我的素材库',
    description: '管理和组织您的设计收藏',
    noLibrariesFound: '未找到素材库',
    noLibrariesDescription: '创建您的第一个素材库，开始组织您的设计',
    untitledLibrary: '未命名素材库',
    noDescription: '暂无描述',
    created: '创建于',
    loading: '正在加载素材库...',
    edit: '编辑素材库',
    create: '创建素材库',
    delete: '删除素材库',
    name: '素材库名称',
    type: '类型',
    category: '分类',
    tag: '标签',
    editDescription: '简介',
    html: 'HTML 内容',
    save: '保存素材库',
    cancel: '取消',
    confirmDelete: '确定要删除此素材库吗？',
    deleteSuccess: '素材库已成功删除',
    createSuccess: '素材库已成功创建',
    updateSuccess: '素材库已成功更新',
    errorLoading: '加载素材库失败',
  },
  libraryView: {
    backToLibraries: '返回素材库',
    libraryItems: '素材库项目',
    browseItems: '浏览此收藏中的项目',
    emptyLibrary: '此素材库为空',
    addFirstDesign: '添加您的第一个设计到此素材库',
    untitledItem: '未命名项目',
    loading: '正在加载素材库项目...',
    editItem: '编辑项目',
    deleteItem: '删除项目',
    confirmDelete: '确定要删除此项目吗？',
    itemDeleted: '项目已成功删除',
    itemUpdated: '项目已成功更新',
    errorLoading: '加载素材库项目失败',
  },
  create: {
    title: '一分钟制作{dynamicText}！',
    makeA: '制作',
    inAMinute: '仅需一分钟！',
    createTitle: '你现在想设计什么？',
    generating: '生成中...',
    promptLoading: '请稍等片刻，您的设计正在创建中...',
    dynamicTexts: {
      Poster: '图文海报',
      Banner: '产品横幅',
      Thumbnail: '视频封面',
      PPT: 'PPT',
      Meme: '表情包',
    },
    dynamicPlaceholders: [
      '设计一个简约的餐厅菜单，突出特色菜品和促销活动...',
      '做一个旅行景点海报。目的地是内蒙古沙漠星空，3天2晚，暑期活动...',
      `设计一张活动海报，分为两个视觉层次：「背景图」和「前景文字排版」。文字排版风格：现代主义风格...`,
      '制作一个声乐课程海报。包含 5 周课程内容，4999 元，讲师介绍（照片）...',
    ],
    library: {
      title: '素材库',
      manage: '管理素材库',
      select: '选择素材库以预览项目',
      selectAll: '全选',
      deselectAll: '取消全选',
      itemCount: '{{selected}}/{{total}}',
      noLibraries: '未找到素材库',
      preview: '预览',
      itemSelected: '已选择项目',
      itemsSelected: '已选择项目',
      addToDesign: '添加到设计',
      clickToSelect: '点击选择',
      removeFromDesign: '从设计中移除',
      dragToCanvas: '拖拽到画布',
      searchPlaceholder: '搜索素材库项目...',
      createNew: '创建新素材库',
      deleteLibrary: '删除素材库',
      editLibrary: '编辑素材库',
      confirmDelete: '确定要删除此素材库吗？',
      libraryDeleted: '素材库已成功删除',
      libraryCreated: '素材库已成功创建',
      libraryUpdated: '素材库已成功更新',
    },
    esmNotSupportedTitle: '浏览器不支持',
    esmNotSupportedDesc: '您的浏览器不支持所需功能。请使用 Chrome、Edge 或 Safari 等现代浏览器。',
    inputRequired: '请输入内容',
    inputRequiredDesc: '请提供文字描述或上传图片以继续',
    projectCreationFailed: '项目创建失败',
    projectCreationErrorDesc: '创建项目时发生错误，请重试。',
    tryAgain: '重试',
    uploadImage: '参考图片',
    attach: '上传附件',
    attachTips: '添加附件 - 上传参考图片、素材或文档来增强您的设计',
    addMaterial: '添加素材',
    addMaterialTips: '添加图片素材到设计',
    giveInspirationPrompt: '获取灵感',
    dynamicTextOptions: ['海报', '横幅', '迷因'],
    generate: '生成',
    singleMode: '单个',
    batchMode: '批量',
    generateBatch: '批量生成',
    promptPlaceholder: '描述您想要的设计（例如："一个现代咖啡店的海报"）',
    modelLabel: '选择模型：',
    sizeLabel: '选择尺寸：',
    presetTitle: '或选择预设提示：',
    use: '使用',
    usePrompt: '使用提示词',
    loginRequired: '需要登录',
    loginMessage: '欢迎来到 Seede AI',
    continueWithEmail: '使用邮箱继续',
    continueWithPhone: '使用手机号继续',
    loginButton: '登录',
    registerButton: '注册',
    maybeLater: '暂时不了',
    referenceUrl: '阅读链接',
    enterReferenceUrl: '请输入参考链接',
    colorScheme: '配色方案',
    deviceNotSupportedTitle: '暂不支持移动端生成',
    deviceNotSupportedDesc: '为获得最佳体验，请使用电脑访问。当前暂不支持移动设备。',
    multimodal: '多模态',
    whatToCreateToday: '你现在想设计什么？',
    designDimensions: '设计尺寸',
    sizes: {
      auto: '自适应',
      height: '高度',
      width: '宽度',
      custom: '自定义',
      wechatMpCover: '微信公众号封面',
      mobilePoster: '手机',
      redNote: '小红书图文',
      newsletter: 'Newsletter',
      infographic: '长图',
      instagram: 'Instagram',
      facebook: 'Facebook',
      twitter: 'X (Twitter)',
      linkedin: 'LinkedIn 帖子',
      pinterest: 'Pinterest',
      youtube: 'YouTube 缩略图',
      tvScreen: '电视屏幕',
      a2: 'A2',
      a3: 'A3',
      a4: 'A4',
      a5: 'A5',
      a2h: 'A2 (横向)',
      a3h: 'A3 (横向)',
      a4h: 'A4 (横向)',
      a5h: 'A5 (横向)',
      businessCard: '名片',
      postcard: '明信片',
      flyer: '传单',
      brochure: '宣传册',
      poster: '海报',
      banner: '横幅',
      billboard: '广告牌',
      menu: '菜单',
      pullUpBanner: '易拉宝',
      rollUpBanner: '易拉宝 | 80×200cm',
      tableCard10x15: '桌卡 | 10×15cm',
      tableCard15x20: '桌卡 | 15×20cm',
      lightBoxPoster: '灯箱海报 | 60×90cm',
    },
    custom_size: {
      title: '创建自定义尺寸',
      name: '名称（可选）',
      name_placeholder: '我的自定义尺寸',
      width: '宽度（像素）',
      height: '高度（像素）',
      cancel: '取消',
      create: '创建',
    },
    size_categories: {
      social: '社交媒体',
      device: '设备屏幕',
      print: '印刷品',
      aspect: '宽高比',
      custom: '自定义尺寸',
      add_custom: '添加自定义尺寸',
    },
    credits: '积分',
    guide: '获取更多点数',
    projectType: {
      title: '更改项目可见性',
      public: {
        label: '公开',
        description: '任何人都可以查看和二次创作',
        tips: '任何人都可以二次创作此项目。这意味着可以复制并在此基础上编辑。要停用二次创作，请升级后切换到私有。',
      },
      private: {
        label: '私有',
        description: '仅对您自己可见，除非开启分享',
        tag: '专业版',
      },
      upgrade: '升级到专业版',
    },
    mobileWarning: {
      title: '暂不支持移动设备',
      message: '请使用电脑浏览器访问',
      button: '知道了',
    },
    optimizePrompt: {
      title: '提示词智能优化',
      action: '智能提示词优化（适用于少于60个字符的提示词）',
      aiCommunication: '通过AI优化您的设计提示词，获得更精确的结果',
      aiCommunicationShort: 'AI 设计沟通',
      optimize: '优化',
      description: '您的提示词似乎有点简短。是否要使用我们优化后的版本来获得更好的效果？',
      original: '原始提示词：',
      optimized: '优化后的提示词：',
      optimizing: '正在优化提示词...',
      originalDesc: '将作为优化基础的原始输入提示词。',
      optimizedDesc: '您可以编辑由AI生成的优化提示词',
      useOriginal: '使用原始版本',
      useOptimized: '使用优化版本',
    },
    optimizationChat: {
      generateNow: '立即生成',
      title: 'AI 设计需求优化',
      description: '让我们完善您的设计需求以获得最佳效果',
      startPrompt: '您需要哪些特定的设计元素或风格？',
      customInputPlaceholder: '如果你对已有选项不够满意，你还可以在这里输入你的需求...',
      thinking: '处理中...',
      optimizedPromptLabel: '优化后的提示词：',
      submitCustom: '提交',
      continueOptimizing: '继续优化',
      clickToContinue: '点击下方选项继续优化',
      retry: '重试',
      errorGenerating: '内容生成错误',
      errorMessage: '内容生成失败。请重试。',
      finalPromptError: '最终提示词生成失败。',
      conversationError: '无法继续对话。',
      nextQuestionError: '无法生成下一个问题。',
      optimizeError: '无法启动优化对话。',
      useOptimized: '使用优化提示词',
      finalPromptSuccess: '您的设计提示词已优化完成！',
      maxStepsReached: '已达到最大对话步骤',
      designRequirements: '设计需求',
      visualStyle: '视觉风格',
      layoutPreferences: '布局偏好',
      colorScheme: '配色方案',
      typographyChoices: '字体选择',
      additionalNotes: '附加说明',
    },
    insufficientCredits: {
      title: '点数不足',
      description: '您已用完所有点数。邀请好友获取更多点数！',
    },
    generateMode: {
      title: '生成模式',
      fast: '快速模式',
      workflow: '高级模式',
      fastDescription: '单 Agent 模式，生成速度快',
      workflowDescription: '多 Agent 的生成模式，生成速度快，设计质量更高',
    },
    batch: {
      design: '设计',
      designs: '设计',
      generateOne: '生成 1 个设计',
      generateMultiple: '生成 {{count}} 个设计',
      title: '批量生成',
      description: '一次生成多个设计变体，探索不同的创意方向。',
      hint: '更多设计 = 更多创意选择',
      single: '一次生成 1 个设计',
      double: '一次生成 2 个设计',
      quad: '一次生成 4 个设计',
      nine: '一次生成 9 个设计',
      singleImage: '单个',
      multipleImages: '设计',
    },
    inputRequiredTitle: '需要输入',
    promptTemplateHint: '点击上方的提示词模板快速开始，或输入您自己的创意想法',
    promptTemplates: '提示词模板',
    recentProjects: '我的项目',
    latestTemplates: '最新模板',
    featuredProjects: '精选设计',
    communityFavorites: '社区热门和趋势设计',
    loadingFeatured: '正在加载精选项目...',
    continueWork: '从上次的地方继续',
    featured: '精选设计',
    readyToUse: '向下滑动查看更多提示词案例，点击即可使用创意提示词',
    viewAll: '查看全部',
    viewMore: '查看更多',
    items: '个项目',
    view: '查看',
    open: '打开',
    noRecentProjects: '未找到最近的项目',
    firstDesign: '通过选择模板或使用 AI 生成来创建您的第一个设计',
    noTemplates: '暂无可用模板',
    noFeaturedProjects: '暂无精选设计',
    checkBackLater: '稍后回来查看社区的新精选设计',
    colorSchemes: {
      defalt: '默认配色方案',
      monochrome: '单色',
      business: '商务专业',
      cafe: '咖啡',
      restaurant: '餐厅',
      vintage: '复古',
      modern: '现代企业',
      nature: '自然',
      luxury: '奢华',
      tech: '科技',
      pastel: '柔和色调',
      retro: '复古风格',
      custom: '自定义颜色',
    },
  },
  pricing: {
    title: '用 Seede AI 开启设计之旅',
    getStarted: '开始使用',
    designBeginner: '设计新人',
    loveDesign: '成为设计爱好者',
    designLikeAPro: '成为专业设计师',
    designExpert: '成为设计专家',
    subscribe: '免费试用',
    popular: '热门',
    freePlan: '免费版',
    freePlanDesc: '适用于个人用户的基础功能',
    freeFeatures: ['5 积分', '基础设计功能', '社区支持', '免费图像处理工具'],
    starterPlan: '入门版',
    starterPlanDesc: 'AI设计入门的完美选择',
    starterFeatures: ['200个AI点数（每月更新）', '高级设计模板', '邮件支持', '自定义品牌元素'],
    proPlan: '专业版',
    proPlanDesc: '适用于专业用户的高级功能',
    proFeatures: ['1000个AI点数（每月更新）', '高级设计模板', '优先支持', '自定义品牌元素'],
    tryNow: '立即购买',
    choosePlan: '立即解锁专业设计能力，让创意变现更简单',
    0: {
      creditsPack: '0 AI 积分包',
      creditsPackDesc: '新手专享 · 快速体验',
      tips: '适合简单项目，探索 Seede AI 的功能',
      creditsFeatures: [
        '每日登录赠 5 水滴（每日 05:00 刷新）',
        '新注册用户，额外赠送 10 水滴（有效期 12 个月）',
        '图文生成 / AI 对话编辑：5-10 次',
        '手动修改 / 导出：无限次数',
        '新人权益：',
        '邀请好友，双方均可获得额外积分',
        '全功能编辑器',
        '文本：可随意修改、调整与删除',
        '图片：支持上传、替换，并提供 AI 编辑（消耗积分）',
        '社区海量优质模板',
        '可处理文本上限：500 字',
        '可上传素材配图上限：3 张',
        '支持导入 PDF / Word（最大 5 MB）',
        '单次生成最多 5 页图',
        '标准导出（含水印）',
        '支持导出：PNG / JPG / WebP',
      ],
    },
    50: {
      creditsPack: '50 AI 积分包',
      creditsPackDesc: '新手专享 · 快速体验',
      tips: '去掉水印并解锁高级功能',
      creditsFeatures: [
        '每日登录赠 5 水滴（每日 05:00 刷新）',
        '购买 50 水滴 (有效期 12 个月)',
        '图文生成 / AI 对话编辑：25-50 次',
        '手动修改 / 导出：无限次数',
        '包含「设计新人」全部权益，外加：',
        '解锁「私密生成」',
        '字体/图片可用于商业用途',
        '可处理文本上限：3000 字',
        '可上传素材配图上限：20 张',
        '支持导入 PDF / Word（最大 15 MB）',
        '单次生成最多 10 页图',
        '高清导出（无水印）',
        '额外支持导出：PDF / PPT / HTML',
      ],
    },
    300: {
      creditsPack: '300 AI 积分包',
      creditsPackDesc: '热门推荐 · 超值优惠',
      tips: '享受更高上限、更强模型与优先体验资格',
      creditsFeatures: [
        '每日登录赠 5 水滴（每日 05:00 刷新）',
        '购买 300 水滴 (有效期 12 个月)',
        '图文生成 / AI 对话编辑：150-300 次',
        '手动修改 / 导出：无限次数',
        '包含「设计爱好者」全部权益，外加：',
        '可处理文本上限：5000 字',
        '单次生成最多 20 页图',
        '新功能的优先内测资格',
        '抢先体验更先进的 AI 模型',
      ],
    },
    100: {
      creditsPack: '100 AI 积分包',
      creditsPackDesc: '企业首选 · 专业版',
      tips: '300 积分可用于 150 次高级模型设计生成或编辑，300 次普通模型生成或编辑',
      creditsFeatures: ['300 积分 (有效期 1 月)', '包含 39.9 元版所有功能'],
    },
    tips: '享受 {{count}} 次专业设计体验',
    comingSoon: '即将推出',
    perMonth: '/月',
    betaNoticeTitle:
      '感谢每一位在 Seede AI 公测期提出真诚反馈的用户。根据大家的建议，我们对定价做了些优化，即日生效。',
    betaNoticeItems: [
      {
        description:
          '上线「设计新人」免费套餐：每日可领取 5 水滴（积分），可使用绝大部分 Seede AI 功能。',
      },
      {
        description: '暂停原「10 元」套餐，其权益已并入原「21 元」套餐。',
      },
    ],
    testimonials: {
      title: '用户评价',
      subtitle: 'Seede AI 帮助用户创建令人惊叹的设计，并且好评如潮。',
    },
    stats: {
      activeUsers: '活跃用户',
      designsCreated: '设计作品',
      satisfactionRate: '满意度',
    },
    faq: {
      title: '常见问题',
      subtitle: '关于 Seede AI 定价和使用问题的解答',
      productHighlights: '产品亮点包括：',
      items: [
        {
          question: 'Seede AI 是什么？',
          answer:
            'Seede AI 是一款 AI 设计工具，可帮助您在一分钟内生成高质量的、文字/图片均可自由编辑的设计作品。无需任何设计经验，任何文案 + 配图输进去，都能做出精美图文设计，适用于商品详情页 / 社交媒体内容 / 政策解读 / 易拉宝 / 科普图文 / 活动议程 / 课程海报...等多种场景。',
          link: {
            text: 'Seede AI 直出设计作品案例入口',
            url: 'https://seedesign.feishu.cn/wiki/S65OwuCLSiCm2qkZHUhccFVJnGg',
          },
          highlights: [
            '内容优先，完整保留你的文字与结构：输入的文字、段落和结构都会被「完整保留」，并通过更具设计感的方式呈现。',
            '随心编辑，灵活修改文字和替换图片：一键生成精美设计后，文字和图片都可以自由替换、调整、编辑或删除，创作完全由你掌控。',
            '文字准确，精确呈现全球语言与格式：支持 100+ 语言和各种文档格式，一键转换，输出精准无乱码，全球内容轻松设计。',
          ],
        },
        {
          question: '免费版和付费版有什么区别？',
          answer:
            '免费版：每日登录赠 5 水滴（积分），提供基础设计功能，包括全功能编辑器、社区优质模板、标准导出（含水印）等。',
          answerAfterLink:
            '付费版：解锁更多功能，如高清导出（无水印）、更多格式导出、商业授权、更多文本和图片处理上限等。',
        },
        {
          question: 'Seede AI 的水滴（积分）是什么？',
          answer:
            '水滴（积分）是 Seede AI 的核心计费单位。「高级模型」设计生成或再次编辑，每次消耗 2 积分，「标准模型」设计生成或再次编辑，每次消耗 1 积分。若选择「批量生成」模式，积分消耗将按倍数计算。例如：一次批量生成 4 张作品，并使用高级模型，则该次共消耗 8 积分。',
          subItems: [
            '高级模型包括：Gemini 3 Pro（默认）、Gemini 2.5 Pro、Claude 4.5、GPT-5、Claude 4.5 等系列',
            '标准模型包括：Gemini 2.5 Flash、Kimi K2、GPT-5 mini、Qwen3、Deepseek V3、GLM 4.6、Doubao、MiniMax 等系列',
          ],
        },
        {
          question: '如何获得更多水滴（积分）？',
          answer: '获得水滴（积分）主要有 5 种方式：',
          subItems: [
            '新注册用户，额外赠送 10 水滴',
            '每日登录赠 5 水滴（每日 05:00 刷新）',
            '通过「邀请好友」方式，双方各获得 5 水滴',
            '通过「付费购买」方式获得水滴',
            '参与不定期推出的活动，获得额外奖励水滴',
          ],
        },
        {
          question: '水滴（积分）是否有有效期？',
          answer: '是的，不同类型的水滴（积分）有效期如下：',
          subItems: [
            '新注册用户，额外赠送 10 水滴：有效期 12 个月',
            '每日登录水滴：每日 05:00 刷新',
            '邀请好友奖励水滴：有效期 12 个月',
            '付费购买水滴：有效期 12 个月，暂不支持延期或划转',
            '活动奖励水滴：根据具体活动规则，确定有效期',
          ],
        },
        {
          question: '水滴（积分）消耗顺序是怎样的？',
          answer: '水滴（积分）按以下优先顺序进行消耗：',
          subItems: [
            '活动奖励水滴',
            '每日登录水滴',
            '邀请好友奖励水滴',
            '新注册用户赠送水滴',
            '付费购买水滴',
          ],
        },
        {
          question: '如何邀请好友获得奖励水滴（积分）？',
          answer: '请访问页面：',
          link: {
            text: '邀请好友入口',
            url: 'https://seede.ai/invite',
          },
          answerAfterLink:
            '分享「邀请链接」给好友，好友注册并「完成首次设计生成」后，您和好友会各获得 5 水滴奖励。',
        },
        {
          question: '在 Seede AI 上创作的设计作品归谁所有？',
          answer:
            '您的所有设计源文件（在线保存）与作品均 100% 归您所有。Seede AI 严格遵守数据隐私政策，未经您的授权，我们无法访问或使用您的任何设计内容。',
        },
        {
          question: '设计作品可以用于商业用途吗？',
          answer: '免费版：仅限个人非商业使用。',
          answerAfterLink:
            '付费版：在「付费购买水滴」有效期内，使用任意类型积分，创作的作品均包含商业使用授权，字体与图片素材均可用于商业用途。',
        },
        {
          question: '是否提供学生/教育优惠？',
          answer: '目前暂不支持，未来会视情况推出相关方案。',
        },
        {
          question: '如何取消订阅或申请退款？',
          answer:
            '付款后 3 个自然日内，若所购买套餐的水滴（积分）消耗符合下表所列标准，即可申请全额退款。',
          table: {
            headers: ['套餐', '金额', '可全额退款的条件（剩余积分 ≥）'],
            rows: [
              ['成为设计爱好者', '¥ 21', '40'],
              ['成为设计专家', '¥ 99.99', '280'],
            ],
          },
          answerAfterTable: '如满足条件，可',
          link: {
            text: '联系我们',
            url: 'https://seede.ai/contact',
          },
          answerAfterLink: '，提交退款申请，我们将尽快为您处理。',
        },
        {
          question: '如何联系 Seede 团队？',
          answer: '请访问页面：',
          link: {
            text: '联系我们',
            url: 'https://seede.ai/contact',
          },
        },
      ],
    },
  },
  download: {
    title: '下载客户端',
    subtitle: '选择您的平台开始下载',
    mac: 'Mac',
    macDesc: '适用于 Apple Silicon 和 Intel 芯片',
    windows: 'Windows',
    windowsDesc: '适用于 Windows 10 及以上版本',
    downloadBtn: '立即下载',
  },
  features: {
    title: '功能',
    categories: {
      aiDesign: 'AI 设计',
      getSeede: '获取 Seede',
      tutorials: '教程',
    },
    comingSoon: '即将推出',
    features: {
      templates: {
        title: '模板',
        description: '探索我们专业设计的模板库',
        action: '从模板创建',
      },
      textToDesign: {
        title: '文字生成设计',
        description: '根据文字提示生成设计',
        action: '开始创作',
      },
      imageToDesign: {
        title: '图片生成设计',
        description: '根据参考图片创建设计',
      },
      designIteration: {
        title: '设计迭代',
        description: 'AI驱动的设计优化和改进',
      },
      batchGeneration: {
        title: '批量生成',
        description: '一次性生成多个不同变体的设计',
      },
      updates: {
        title: '更新',
        description: '自动更新，支持手动检查',
      },
      createDesignBoard: {
        title: '创建设计板',
        description: '使用AI设计工具开始新项目',
      },
      textToPoster: {
        title: '文字生成海报',
        description: '根据文字描述生成海报',
      },
      imageToPoster: {
        title: '图片生成海报',
        description: '根据参考图片创建可编辑设计',
      },
    },
  },
  useCases: {
    title: '使用场景',
    description: '探索 Seede AI 如何通过这些强大的使用场景转变您的创意工作流程',
    tryNow: '立即使用',
    socialMedia: {
      title: '社交媒体帖子',
      description: '使用 Seede AI 的设计工具创建引人入胜的社交媒体内容',
    },
    minimalistPoster: {
      title: '极简主义海报',
      description: '使用专业布局设计简洁现代的极简主义海报',
    },
    letterCard: {
      title: '信函卡片',
      description: '创建具有优雅排版和布局的精美信函风格卡片',
    },
    podcastCover: {
      title: '播客封面',
      description: '设计具有Apple风格美学的醒目播客封面艺术',
    },
    videoCover: {
      title: '视频封面',
      description: '创建具有Notion风格简约主义的专业视频缩略图',
    },
    flashCard: {
      title: '闪卡',
      description: '设计布局清晰的有效词汇和学习闪卡',
    },
    newsletter: {
      title: '新闻通讯',
      description: '创建具有清晰排版和图像的专业新闻通讯设计',
    },
  },
  batchMode: {
    title: '批量生成',
    description:
      '您的批量创作正在生成中，查看并选择最符合您愿景的设计。点击任意项目以进一步探索和优化。',
    startAnotherBatch: '开始新批量创建',
    foundPerfectDesign: '找到您的完美设计了吗？',
    emptyStateTitle: '暂无批量设计',
    emptyStateDescription: '通过在创建页面启动批量生成，一次创建多个设计变体。',
    startCreating: '开始创建',
    regenerate: '重新生成',
    generationFailed: '生成失败',
    yourPrompt: '提示词',
    edit: '编辑',
    status: {
      pending: '等待中',
      generating: '生成中',
      completed: '已完成',
      error: '错误',
    },
  },
  designError: {
    title: '无法访问设计',
    messages: {
      Forbidden: '您没有权限查看此项目。它可能是私有的或已被删除。',
      NetworkError: '尝试获取资源时发生网络错误。请检查您的网络连接并重试。',
      NotFound: '找不到请求的资源。请检查 URL 并重试。',
      Unauthorized: '您没有权限访问此资源。请登录或联系客服。',
      ServerError: '服务器遇到错误。请稍后重试或联系客服。',
    },
    errorDetails: '异常详情',
    returnHome: '返回主页',
    errorIcon: '错误提示图标',
  },
  preview: {
    title: '预览',
    share: '分享',
    description: '预览并编辑您的设计',
    export: '导出',
    back: '返回创建',
    readonly: '只读模式',
    createNew: '创建新项目',
    chat: '对话',
    edit: '编辑',
    layers: '图层',
    images: '图片',
    text: '文字',
    dragToCanvas: '拖拽到画布',
    library: '素材库',
    send: '发送',
    sending: '正在生成...',
    sendShortcut: '按 Shift + Enter 发送',
    credits: '积分',
    typeMessage: '描述您的设计需求，让 AI 为您优化...',
    designingPoster: '🎨 Seede AI 正在设计您的创意作品...',
    tokensGenerated: '{{count}} 代码已生成',
    generationComplete: '✅ 设计生成完成！',
    savingMasterpiece: '💾 正在保存您的杰作...',
    generationError: '🔄 糟糕！出了点问题。让我再试一次...',
    generationCompleted: '生成完成',
    generationStopped: '⏹️ 生成已停止',
    stopGeneration: '停止生成',
    somethingWrong: '抱歉，出了点问题，请稍后重试。',
    imageEditSuccess: '图片编辑成功！您的设计已更新。',
    textEditSuccess: '文本编辑成功！您的设计已更新。',
    timeoutError: '等待设计渲染超时。这通常是由于生成代码存在语法错误导致的。',
    needMoreCredits: '您需要更多积分才能继续',
    getMoreCredits: '购买积分',
    inviteForCredits: '获取免费积分',
    upgradeAccount: '升级您的账户以获得无限访问权限',
    creditsExhausted: '您的积分已用完',
    freeCreditsAvailable: '邀请朋友获得5个免费积分',
    limitReached: '您已达到使用限制',
    continueWithCredits: '添加积分以继续创建精彩设计',
    copy: '复制',
    error: '错误',
    regenerate: '重新生成',
    task: {
      analysis: '需求分析',
      typography: '文字排版',
      style: '设计风格',
      layout: '页面布局',
      code: '设计构建',
      build: '设计合成',
      image: '图像处理',
    },
    snapshot: {
      title: '项目快照',
      description: '项目版本快照',
      noPreviewAvailable: '无可用预览',
      restoreSnapshot: '恢复到这个版本',
      viewSnapshot: '查看快照',
      snapshotDescription: '项目版本快照',
      restoreConfirm: '您确定要恢复此版本吗？',
      restoreSuccess: '版本恢复成功',
      restoreFailed: '恢复设计版本失败。',
      created: '快照已创建',
      loading: '正在加载快照...',
    },
    chatMessage: {
      copyToClipboard: '复制到剪贴板',
      copySuccess: '已复制到剪贴板',
      copySuccessDescription: '文本已成功复制',
      copyFailed: '复制失败',
      copyFailedDescription: '无法复制文本到剪贴板',
    },
  },
  exportMenu: {
    title: '导出设置',
    description: '选择导出格式和质量',
    exportImage: '导出',
    copyToClipboard: '复制到剪贴板',
    copying: '正在复制...',
    exportAll: '导出全部',
    exportAllPages: '一次性导出所有页面',
    selectPage: '选择页面',
    selectedPages: '{{count}} 个选中页面',
    fileName: '文件名',
    page: '页面',
    selectPageError: '请至少选择一个页面进行导出',
    choosePage: '选择要导出的页面',
    fileFormat: '文件格式',
    selectFormat: '选择格式',
    pngFormat: 'PNG（高质量）',
    jpgFormat: 'JPG（压缩）',
    webpFormat: 'WebP（现代）',
    pdfFormat: 'PDF（文档）',
    mp4Format: 'MP4 (视频)',
    pptFormat: 'PPT (测试版)',
    fps: '帧率',
    duration: '时长',
    resolution: '分辨率',
    selectResolution: '选择分辨率',
    standard: '标准（1x）',
    highRes: '高分辨率（2x）',
    ultraHighRes: '超高分辨率（3x）',
    extremeHighRes: '极高分辨率 ({{value}}x)',
    printOptimized: '打印优化',
    dpi: 'DPI（每英寸点数）',
    selectDpi: '选择 DPI',
    cmykColorSpace: 'CMYK 色彩空间',
    copiedToClipboard: '已复制到剪贴板',
    copySuccess: '图片已成功复制到剪贴板',
    copiedAs: '已复制为 {{format}}',
    exporting: '正在导出...',
    preparingDownload: '正在准备下载...',
    downloadComplete: '您的下载已准备就绪',
    downloadFailed: '导出失败，请尝试缩小尺寸或者切换其他格式重试',
    success: '成功',
    error: '错误',
    copyFailed: '复制失败，请重试',
    cmykMode: 'CMYK 色彩空间',
    printSize: '打印尺寸 (cm)',
    customSize: '自定义尺寸 (cm)',
    quickPresets: '快速预设',
    printOptimizedDescription: '为专业打印优化',
    multiplePages: '多页面',
    allPages: '所有页面',
    currentPage: '当前页面',
    downloadStarted: '下载已开始',
    processingFiles: '正在处理文件...',
    viewingDistance: {
      veryFar: '适用于广告牌和超大尺寸格式（10米以上）',
      far: '适用于远距离观看（3-10米）',
      medium: '适用于正常观看距离（1-3米）',
      close: '适用于近距离观看（0.3-1米）',
      detailed: '适用于精细专业印刷（小于0.3米）',
    },
    sizeTable: {
      title: '标准纸张尺寸参考表',
      format: '格式',
      width: '宽度',
      height: '高度',
      dimensions: '厘米',
      clickToApply: '点击应用此尺寸',
      customSize: '自定义尺寸',
    },
    copyNotSupported: '不支持复制',
    copyNotSupportedDesc: '您的浏览器不支持将图片复制到剪贴板',
    bleedSize: '出血线尺寸 (mm)',
    bleedSizeDescription: '用于裁切的额外区域（推荐：3mm）',
    badgeStyle: '徽标',
    selectBadgeStyle: '选择徽标',
    hideBadge: '隐藏徽章',
    badgeProOnly: '付费用户可以选择隐藏徽标',
  },
  signIn: {
    title: '登录',
    email: '邮箱',
    createYourAccount: '创建您的账号',
    signUp: '注册',
    signIn: '登录',
    welcomeBack: '欢迎回来！',
    joinToday: '立即加入 Seede.ai',
    accessTools: '只需一分钟即可帮助您创建出色的视觉效果，无需任何设计技能。',
    googleUnavailable: 'Google 登录不可用',
    useEmailInstead: '请改用邮箱登录。',
    emailPlaceholder: '请输入您的邮箱',
    inputPlaceholder: '请输入',
    password: '密码',
    passwordPlaceholder: '请输入您的密码',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    continueWith: '使用',
    continueWithEmail: '使用邮箱继续',
    continueWithPhone: '使用手机号继续',
    phone: '手机号',
    phonePlaceholder: '请输入您的手机号',
    smsCode: '验证码',
    emailCode: '验证码',
    smsCodePlaceholder: '请输入6位验证码',
    sendCode: '发送验证码',
    resendCode: '重新发送',
    smsCodeSent: '短信验证码发送成功',
    smsCodeRequired: '请输入短信验证码',
    phoneRequired: '请输入手机号',
    inviteCode: '邀请码（可选）',
    haveInviteCode: '有邀请码？',
    inviteCodePlaceholder: '请输入邀请码',
    loginButton: '登录',
    registerButton: '注册',
    noAccount: '没有账号？立即注册',
    hasAccount: '已有账号？立即登录',
    loginFailed: '登录失败。请检查您的邮箱和密码。',
    networkError: '网络连接异常，请检查您的网络设置后重试',
    passwordMismatch: '密码不匹配',
    orContinueWith: '或使用以下方式继续',
    agreeToTerms: '点击"继续使用 Google 账号"或注册，即表示您同意我们的',
    terms: '服务条款',
    and: '和',
    privacy: '隐私政策',
    agreeToTermsRequired: '请接受我们的服务条款和隐私政策以继续',
    forgotPassword: '忘记密码？',
    emailRequired: '请输入您的邮箱地址',
    invalidEmail: '请输入有效的邮箱地址',
    emailCodeSent: '邮箱验证码发送成功',
    emailMessages: {
      6001: '邮箱是必填项',
      6002: '邮箱格式无效',
      6003: '该邮箱已被注册',
      6004: '不允许使用临时邮箱地址',
      6005: '发送邮箱验证码失败',
    },
    messages: {
      6001: '该邮箱或手机号已被注册，请使用其他账号注册',
      6002: '邮箱、手机号或密码错误，请重新输入',
      6003: '密码长度不足，请设置更安全的密码',
      6004: '邮箱格式不正确，请输入有效的邮箱地址',
      6005: '不允许使用临时邮箱地址进行注册',
    },
    smsMessages: {
      6001: '手机号码是必填项',
      6002: '手机号码格式无效',
      6003: '该手机号码已被注册',
      6004: '发送短信验证码失败',
      6005: '服务器内部错误',
    },
  },
  forgotPassword: {
    title: '忘记密码',
    description: '输入您的邮箱地址，我们将向您发送验证码以重置密码。',
    seoTitle: '忘记密码 - Seede AI',
    seoDescription: '重置您的 Seede.ai 账户密码，快速安全地恢复账户访问权限。',
    seoKeywords: '忘记密码,重置密码,账户恢复,密码找回,seede ai',
    resetTitle: '重置密码',
    resetDescription: '我们已将验证码发送到您的邮箱：{{email}}',
    verificationCode: '验证码',
    codePlaceholder: '请输入6位验证码',
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入新密码（至少6位）',
    sendCode: '发送验证码',
    sending: '发送中...',
    resetButton: '重置密码',
    resetting: '重置中...',
    backToSignIn: '返回登录',
    backToEmail: '重新输入邮箱',
    successTitle: '密码重置成功！',
    successDescription: '您的密码已成功重置，现在可以使用新密码登录您的账户。',
    signInNow: '立即登录',
    sideTitle: '安全可靠的密码重置',
    sideDescription: '我们采用安全的验证流程来保护您的账户安全。',
    emailRequired: '请输入您的邮箱地址',
    invalidEmail: '请输入有效的邮箱地址',
    sendCodeFailed: '发送验证码失败，请重试',
    codeRequired: '请输入验证码',
    passwordRequired: '请输入新密码',
    passwordTooShort: '密码长度至少为6位',
    passwordMismatch: '两次输入的密码不一致',
    resetFailed: '重置密码失败，请重试',
  },
  designHeaderMenu: {
    back: '返回',
    view: '查看',
    layout: '布局',
    zoom: '缩放',
    zoomIn: '放大',
    zoomOut: '缩小',
    zoomToFit: '适应画布',
    shortcuts: '键盘快捷键',
    help: '帮助',
    docs: '文档',
    support: '支持',
    untitled: '未命名',
    readonly: '只读',
    export: '导出',
    project: '项目',
    makePublic: '设为公开',
    makePrivate: '设为私有',
    visibility: '可见性',
    public: '公开 - 任何拥有链接的人都可以查看',
    private: '私有 - 只有您可以查看',
    visibilitySuccess: '项目可见性已更新',
    visibilitySuccessDesc: '您的项目现在是{{visibility}}',
    visibilityFailed: '更改可见性失败',
    visibilityFailedDesc: '更改项目可见性时出现错误，请稍后重试。',
    save: '保存',
    saving: '保存中...',
    savingDesc: '正在保存您的项目。',
    saveSuccess: '项目已保存',
    saveSuccessDesc: '您的项目已成功保存。',
    saveFailed: '保存失败',
    edit: '编辑',
    undo: '撤销',
    redo: '重做',
    cut: '剪切',
    copy: '复制',
    paste: '粘贴',
    duplicate: '复制对象',
    delete: '删除',
    selectAll: '全选',
    copyStyle: '复制样式',
    pasteStyle: '粘贴样式',
    saveFailedDesc: '保存项目失败，请重试。',
    horizontalLayout: '水平布局',
    verticalLayout: '垂直布局',
    present: '演示模式',
  },
  templates: {
    title: '模板',
    description: '探索我们专业设计的模板库',
    loading: '正在加载模板...',
    filter: '按标签筛选',
    allTags: '全部标签',
    noTemplates: '未找到模板',
    createFromTemplate: '从模板创建',
    backToAllTemplates: '返回模板首页',
    allTemplates: '所有模板',
    categories: '分类',
    browseByCategory: '浏览分类',
    recentlyUpdated: '最近更新',
    viewAll: '查看更多',
  },
  templateTags: {
    Untagged: '未分类',
    xiaohongshu: '小红书',
    'Album cover': '专辑封面',
    solarTerms: '节气',
    menu: '菜单',
    invitation: '邀请函',
    'social-media': '社交媒体',
    signage: '标识牌',
    'wechat-cover': '微信封面',
    infographic: '信息图表',
    mobile: '移动端',
    youtube: 'YouTube',
    post: '帖子',
    flashCard: '闪卡',
    wechat: '微信',
    officialAccount: '公众号',
    instagram: 'Instagram',
    linkedInAds: 'LinkedIn广告',
    background: '背景',
    poster: '海报',
    flyer: '传单',
    wedding: '婚礼',
    quoteCard: '语录卡片',
    recruitmentPoster: '招聘海报',
    milestone: '里程碑',
    card: '卡片',
  },
  templateDetail: {
    title: '模板详情',
    backToTemplates: '返回模板库',
    useTemplate: '使用此模板',
    loading: '正在加载模板...',
    description: '描述',
    tags: '标签',
    copyPrompt: '复制提示词',
    remix: 'Remix',
    creating: '创建中...',
    relatedTemplates: '相关模板',
    templateInfo: '模板信息',
    dimensions: '尺寸',
    category: '分类',
    createdBy: '创建者',
    dateCreated: '创建日期',
    lastModified: '最后修改',
    templateStats: '模板统计',
    usageCount: '使用次数',
    favoriteCount: '收藏次数',
    shareTemplate: '分享模板',
    downloadTemplate: '下载模板',
    similarTemplates: '相似模板',
    editTemplate: '编辑模板',
    previewTemplate: '预览模板',
    templateVersion: '版本',
    templateSize: '文件大小',
    templateFormat: '格式',
    prompt: '提示词',
    promptCopied: '提示词已复制到剪贴板！',
    copyPromptError: '复制提示词失败',
    editContent: '编辑内容',
    contentSpecifications: '内容规格',
    model: '模型',
    universal: '通用',
    version: '版本',
    created: '创建时间',
    updated: '更新时间',
    content: '内容',
    moreElements: '+ 还有 {{count}} 个元素',
    useOriginalPrompt: '使用原始提示词',
    chooseImage: '选择图片',
    variable: '变量 {{index}}',
    enterText: '输入文本',
    copyToClipboard: '复制到剪贴板',
  },
  templatesTag: {
    title: '按标签筛选模板',
    description: '探索按特定标签筛选的模板',
    noTemplatesFound: '未找到该标签的模板',
    loading: '正在加载标签模板...',
    viewAllTemplates: '查看所有模板',
    taggedWith: '标签为 {{tag}} 的模板',
  },
  help: {
    title: '帮助中心',
    faqTitle: '常见问题',
    faqs: [
      {
        question: '如何开始使用 Seede.ai?',
        answer:
          '您可以通过注册账号并登录来开始使用 Seede.ai。我们提供了易于使用的界面和教程，帮助您快速上手。',
      },
      {
        question: 'Seede.ai 支持哪些文件格式?',
        answer: '我们支持常见的图片格式，如 JPG、PNG、SVG 和 Webp。',
      },
      {
        question: '如何升级到 Pro 版本?',
        answer: '您可以在账户设置中找到升级选项，并选择适合您的订阅计划。',
      },
      {
        question: '如何获得技术支持?',
        answer: '您可以查看我们的帮助文档，或通过 hi@seede.ai 联系我们的技术支持团队。',
      },
      {
        question: '如何导出我的设计?',
        answer:
          '编辑完成后，点击右上角的导出按钮，选择您想要的格式（PNG/PDF/JPG）和分辨率进行下载。',
      },
      {
        question: '我可以与团队成员在 Seede.ai 上协作吗?',
        answer: '目前，Seede.ai 尚不支持协作功能。我们正在努力在未来的更新中添加团队协作功能。',
      },
      {
        question: 'Seede.ai 有移动应用吗?',
        answer: '目前，Seede.ai 主要针对桌面使用进行了优化。',
      },
      {
        question: '我可以将 Seede.ai 用于商业项目吗?',
        answer: '当然可以！Seede.ai 可用于个人和商业项目。我们的专业版为专业用途提供了额外功能。',
      },
      {
        question: '你们是否为特定行业提供定制模板?',
        answer:
          '是的，我们提供按行业和用途分类的各种模板。您还可以通过我们的支持渠道请求定制模板。',
      },
      {
        question: 'Seede.ai 多久添加一次新功能?',
        answer:
          '我们定期更新 Seede.ai，添加新功能和改进。我们每季度发布一次重大更新，每月发布小型改进。',
      },
      {
        question: '我可以随时取消订阅吗?',
        answer: '是的，您可以随时从账户设置中取消订阅。您的访问权限将持续到当前计费周期结束。',
      },
    ],
    contactTitle: '需要更多帮助?',
    contactDescription: '如果常见问题未能解决您的问题，请通过以下方式联系我们：',
    contactEmail: '邮箱: hi@seede.ai',
    workingHours: '',
  },
  notFound: {
    title: '页面未找到',
    description: '您访问的页面不存在或已被移动',
    goHome: '返回首页',
  },
  contact: {
    title: '联系我们',
    getInTouch: '联系我们',
    contactDescription: '如有任何疑问或需要支持，请通过以下方式联系我们：',
    contactInfo: '联系信息',
    email: '邮箱: hi@seede.ai',
    socialMedia: '社交媒体',
    followUs: '关注我们获取最新动态',
    twitterHandle: '@seedeAI',
    support: '技术支持',
    supportDescription: '需要产品帮助？',
    business: '商务合作',
    businessDescription: '寻求合作与商业机会',
    contactEmail: 'hi@seede.ai',
  },
  tools: {
    title: '工具',
    mainProduct: '🎨 Seede AI',
    mainProductDesc: 'AI驱动的社交媒体和营销设计工具',
    text2image: '✨ 文本生成图片',
    text2imageDesc: '通过文字描述生成图片',
    video: '🎥 横屏转竖屏视频工具',
    videoDesc: '将横屏视频转换为社交媒体适用的竖屏格式',
    imageProcessing: '🖼️ 图片处理',
    imageProcessingDesc: '编辑和增强您的图片',
    imageGeneration: '🎨 图片生成',
    imageGenerationDesc: '创建AI生成的图片',
    imageUpscaling: '⚡ 图片放大',
    imageUpscalingDesc: '提升图片分辨率和质量',
    backgroundRemoval: '✂️ 背景移除',
    backgroundRemovalDesc: '自动移除图片背景',
    magicEraser: '🪄 魔法橡皮擦',
    magicEraserDesc: '移除图片中不需要的对象',
    playground: '🧩 代码转换可编辑画布',
    playgroundDesc: '将 HTML、React、SVG 转换为可编辑画布并进行设计实验',
    playgroundTitle: 'Code 转可编辑画布实验室',
    playgroundSubtitle: '尝试 HTML、React、SVG 并查看其在 Canvas 上的渲染效果',
    playgroundFeatures: '具有实时预览的交互式设计环境',
    playgroundUsage: '非常适合原型设计和测试设计创意',
  },
  videoTool: {
    title: '横屏转竖屏视频工具',
    description: '将横屏视频转换为社交媒体适用的竖屏格式',
    uploadVideo: '上传视频',
    uploadVideoDesc: '支持 MP4、WebM 等常见格式',
    uploadBackground: '上传背景图片',
    uploadBackgroundDesc: '支持 JPG、PNG 等常见格式',
    clickToUploadVideo: '点击上传视频',
    clickToUploadBackground: '点击上传背景图片',
    bitrate: '码率',
    encoder: '编码器',
    processing: '处理中...',
    processProgress: '处理进度',
    timeElapsed: '已用时间：{{time}}秒',
    startMerge: '开始合成',
    errorMessages: {
      uploadRequired: '请上传视频和背景图片',
      resolutionTooHigh: '视频分辨率过高，请使用较低分辨率的视频或选择更高的编码级别',
      processFailed: '视频处理失败，请重试',
    },
  },
  invite: {
    title: '邀请好友',
    guide: '升级',
    credits: '积分',
    succeededDescription: '验证成功，已获得5个积分',
    pending: '等待验证',
    pendingDescription: '等待用户邮箱验证',
    subtitle: '你和好友都可获得 <b>5</b> 个积分！',
    description: '好友使用你的邀请链接注册并验证账号后，你们都将获得 5 个积分。',
    inviteLink: '邀请链接',
    copyLink: '复制链接',
    copySuccess: '已复制',
    copyDescription: '邀请链接已复制到剪贴板',
    records: '邀请记录',
    recordCount: '共 {{count}} 条记录',
    noRecords: '暂无邀请记录',
    noRecordsDesc: '分享你的邀请链接即可查看记录',
    user: '用户',
    registered: '已注册',
    usage: '使用情况',
    usageDescription: '已使用',
  },
  profile: {
    title: '我的主页',
    usage: '使用情况',
    usageDescription: '已使用积分',
    buyCredits: '立即获取积分',
    inviteFriends: '邀请好友赚积分',
    recentProjects: '最近项目',
    viewAll: '查看全部',
    noProjects: '暂无项目',
    noProjectsDesc: '开始创建你的第一个项目',
    createNew: '创建新项目',
    sendVerification: '发送邮箱验证',
    editProfile: '编辑个人资料',
    changeAvatar: '更换头像',
    displayName: '显示名称',
    bio: '个人简介',
    bioPlaceholder: '介绍一下你自己',
    saveChanges: '保存更改',
    saving: '保存中...',
    cancel: '取消',
    profileUpdated: '个人资料更新成功',
    updateFailed: '个人资料更新失败',
    characterLimit: '{{current}}/{{max}} 字符',
    avatarUploadFailed: '头像上传失败',
    avatarUploadSuccess: '头像上传成功',
    loadMore: '加载更多项目',
    notFound: '未找到用户',
    notFoundDesc: '您查找的用户资料不存在或可能已被删除。',
    backHome: '返回首页',
  },
  imageGenerator: {
    title: 'AI 图像生成',
    subtitle: '将文字瞬间转化为精美图像',
    prompt: {
      label: '提示词',
      placeholder: '描述您想要生成的图像...',
      enhance: '优化提示词',
      enhancing: '优化中...',
      getInspiration: '获取灵感',
      clear: '清除',
    },
    history: '历史记录',
    historyDialog: {
      title: '历史记录',
      description: '查看您之前生成的图像。',
    },
    generate: '生成',
    stylePreset: '风格预设',
    moreOptions: '更多选项',
    createFirst: {
      title: '创建您的第一张图像',
      description: '将您的想法转化为精美视觉效果。只需描述您想要创建的内容，让AI完成魔法般的创作。',
      tryExample: '尝试示例提示词 →',
      outputSize: '输出尺寸：',
    },
    errors: {
      missingPrompt: {
        title: '缺少提示词',
        description: '需要提供提示词才能生成图像。',
      },
      generic: {
        title: '哎呀！出了点问题。',
      },
    },
  },
  success: {
    title: '支付成功！',
    description: '您的付款已成功处理。感谢您的购买。',
    dashboard: '前往控制台',
    createNew: '创建新设计',
  },
  dashboard: {
    RecentDesigns: '最近设计',
    ShowAll: '显示全部',
    ShowStarred: '显示已收藏',
    NewDesign: '新建设计',
    CreateNewProject: '创建新项目',
    LoadingProjects: '加载项目中...',
    WelcomeTitle: '欢迎使用 Seede',
    WelcomeDescription: '点击下方按钮添加新设计项目，开启您的创意之旅。',
    NoProjects: '暂无项目',
    StarredProjects: '已收藏项目',
  },
  project: {
    open: '打开',
    duplicate: '复制',
    delete: '删除',
    star: '收藏',
    unstar: '取消收藏',
    rename: '重命名',
    lastEdited: '最后编辑',
    untitled: '未命名项目',
    confirmDelete: '确定要删除此项目吗？',
    deleteSuccess: '项目已成功删除',
    duplicateSuccess: '项目已成功复制',
  },
  auth: {
    emailVerificationRequired: '需要邮箱验证',
    verificationDescription: '请验证您的邮箱地址。我们已向以下地址发送了验证链接：',
    resendVerificationEmail: '重新发送验证邮件',
    sending: '发送中...',
    verificationEmailSent: '验证邮件发送成功！',
    checkInbox: '请检查您的收件箱和垃圾邮件文件夹以查看验证邮件。',
    verificationEmailFailed: '验证邮件发送失败',
    tryAgainLater: '请稍后重试，如果问题持续存在，请联系客服。',
    enterCode: '输入验证码',
    cancel: '取消',
    verify: '验证',
    verifying: '验证中...',
    verificationSuccess: '验证成功！',
    emailVerified: '您的邮箱已成功验证。',
    verificationFailed: '验证失败',
    invalidCode: '验证码无效，请重试。',
    close: '关闭',
    login: '登录',
    signup: '注册',
    forgotPassword: '忘记密码？',
    resetPassword: '重置密码',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    name: '姓名',
    loginSuccess: '登录成功！',
    signupSuccess: '注册成功！',
    passwordResetSuccess: '密码重置成功！',
    passwordResetRequest: '密码重置链接已发送到您的邮箱',
    invalidCredentials: '邮箱或密码错误',
    accountExists: '该邮箱已存在账户',
    accountNotFound: '未找到该邮箱对应的账户',
    passwordMismatch: '密码不匹配',
    requiredField: '此字段为必填项',
  },
  posterStyles: {
    default: '海报风格',
    minimalist: '极简主义',
    lightshadow: '光影效果',
    gradient: '渐变流动',
    vintage: '复古怀旧',
    geometric: '几何抽象',
    neon: '霓虹光效',
    organic: '自然有机',
    typographic: '排版聚焦',
    service: '温暖服务',
    beauty: '美容与化妆品',
    lifestyle: '生活方式与健康',
    fashion: '时尚前卫',
    isometric: '等距 3D',
    glassmorphism: '玻璃拟态',
    brutalism: '数字粗野主义',
  },
  resize: {
    title: '图片尺寸调整工具',
    description: '调整您的图片尺寸，同时保持图片质量',
    uploadImage: '上传图片',
    dropImage: '点击上传或拖放图片',
    supportedFormats: '支持PNG、JPG、WEBP格式（最大15MB）',
    settings: '调整设置',
    dimensions: '尺寸',
    width: '宽度',
    height: '高度',
    maintainAspectRatio: '保持宽高比',
    format: '格式',
    quality: '质量',
    resize: '调整图片',
    processing: '处理中...',
    reset: '重置',
    result: '结果',
    download: '下载调整后的图片',
    noImageSelected: '请先选择一张图片',
    processingError: '处理图片时出错。请重试。',
    imageLoadError: '加载图片出错。请尝试其他文件。',
  },
  border: {
    title: '图片边框工具',
    description: '为您的图片添加边框，使其在社交媒体上更加突出并获得更多点赞',
    uploadImage: '上传图片',
    livePreview: '实时预览',
    dropImage: '点击上传或拖放图片',
    supportedFormats: '支持PNG、JPG、WEBP格式（最大10MB）',
    settings: '边框设置',
    width: '边框宽度',
    color: '边框颜色',
    style: '边框样式',
    radius: '边框圆角',
    format: '格式',
    quality: '质量',
    apply: '应用边框',
    processing: '处理中...',
    reset: '重置',
    result: '结果',
    download: '下载',
    noImageSelected: '请先选择一张图片',
    processingError: '处理图片时出错',
    imageLoadError: '加载图片出错',
  },
  removeBg: {
    title: '背景移除工具',
    description: '使用 AI 技术一键移除图片背景',
    uploadImage: '上传图片',
    dropImage: '点击上传或拖放图片',
    supportedFormats: '支持 PNG、JPG、WEBP 格式（最大10MB）',
    settings: '输出设置',
    format: '格式',
    quality: '质量',
    removeBackground: '移除背景',
    processing: '处理中...',
    download: '下载',
    reset: '重置',
    result: '结果',
    preview: '预览',
    noImageSelected: '请先选择一张图片',
    processingError: '移除图片背景时出错',
    resultNote: '背景已被移除。您现在可以下载图片。',
    previewNote: '点击"移除背景"处理此图片',
    rembg: '移除背景',
  },
  feedback: {
    title: '您如何评价这个 AI 生成的设计？',
    thankYou: '感谢您的反馈！',
    goodQuality: '优质',
    average: '一般',
    poorQuality: '较差',
    submitSuccess: '反馈提交成功',
    submitError: '提交反馈出错，请重试',
    prompt: '您如何评价这个 AI 生成的设计？',
    description: '您的反馈将帮助我们改进 AI 设计体验',
    poorQualityExplanation:
      '生成质量不佳可能是由于需求不明确或模型限制。可以尝试调整您的提示词或切换到不同的模型。',
    useAnotherModel: '使用其他模型试试',
    tryDifferentModel: '尝试其他模型以获得更好的结果',
  },
  workspace: {
    templatesGroup: '模板',
    promptLibrary: '提示模板库',
    featuredDesigns: '精选设计',
    ai: 'Seede AI',
    create: '创建',
    createTitle: '你现在想设计什么？',
    morePromptTemplates: '更多提示词模板',
    allDesigns: '所有设计',
    recentlyReviewed: '最近查看',
    assets: '素材',
    themes: '主题',
    libraries: '资源库',
    trash: '回收站',
    orders: '账单',
    settings: '设置',
    invite: '邀请好友',
    redeem: '兑换码',
    newDesign: '新建设计',
    searchDesigns: '搜索设计...',
    sortBy: '排序',
    all: '全部',
    recentlyViewed: '最近查看',
    favorites: '收藏夹',
    recentlyUpdated: '最近更新',
    oldestUpdated: '最早更新',
    recentlyCreated: '最近创建',
    oldestCreated: '最早创建',
    noDesignsFound: '未找到设计',
    createFirstDesign: '创建您的第一个设计开始使用',
    loadingProjects: '正在加载项目...',
    deleteProject: '删除项目',
    confirmDelete: '您确定要删除这个项目吗？',
    cancel: '取消',
    delete: '删除',
    loadingMore: '正在加载更多项目...',
    noProjectsFound: '未找到项目',
    createFirstProject: '创建您的第一个项目开始使用',
    newProject: '新建项目',
    searchProjects: '搜索项目...',
    loadingDesigns: '正在加载设计...',
    createNewDesign: '创建新设计',
    welcomeTitle: '欢迎来到您的工作区',
    welcomeDescription: '使用 AI 驱动的工具开始创建惊艳的设计。您的创造力没有边界。',
    createFirstDesignButton: '创建您的第一个设计',
    recentWork: '最近作品',
    allProjects: '所有项目',
    starredProjects: '收藏的项目',
    viewAll: '查看全部',
    emptyState: {
      title: '未找到设计',
      description: '创建您的第一个设计，开始 AI 创造力之旅',
      createButton: '创建新设计',
    },
    filters: {
      all: '全部',
      recent: '最近查看',
      favorites: '收藏',
      public: '公开',
      private: '私密',
    },
    sorting: {
      recentlyUpdated: '最近更新',
      oldestUpdated: '最早更新',
      recentlyCreated: '最近创建',
      oldestCreated: '最早创建',
      alphabetical: '按字母排序',
      reverseAlphabetical: '按字母倒序排序',
    },
    actions: {
      open: '打开',
      view: '查看',
      duplicate: '复制',
      rename: '重命名',
      delete: '删除',
      share: '分享',
      star: '收藏',
      unstar: '取消收藏',
      moveToTrash: '移至回收站',
      restore: '恢复',
      permanentDelete: '永久删除',
    },
    noSearchResults: '未找到搜索结果',
    noSearchResultsDescription: "找不到与 '{{query}}' 匹配的设计。请尝试调整搜索词。",
    clearSearch: '清除搜索',
    noFavorites: '暂无收藏',
    noDesigns: '暂无设计',
  },
  trash: {
    title: '回收站',
    empty: {
      title: '回收站为空',
      description: '当您删除项目时，它们将在此处保留30天，然后被永久删除。',
    },
    confirmPermanentDelete: '您确定要永久删除这个项目吗？此操作无法撤销。',
    deletedAt: '删除于',
    restoredSuccessfully: '项目恢复成功',
    deletedPermanently: '项目已永久删除',
    failedToRestore: '恢复项目失败',
    failedToDelete: '永久删除项目失败',
  },
  settings: {
    title: '设置',
    description: '管理您的账户和偏好设置',
    profile: {
      title: '个人资料',
      subtitle: '管理您的账户设置和偏好',
      profileSection: '个人资料',
      name: '用户名',
      email: '邮箱',
      phone: '手机号',
      noEmail: '未设置',
      noPhone: '未设置',
      verified: '已验证',
      cannotChange: '无法更改',
      avatar: '头像',
      enterName: '输入您的姓名',
      enterEmail: '输入您的邮箱',
      enterPhone: '输入您的手机号',
      save: '保存',
      saving: '保存中...',
      saveProfile: '保存个人资料',
      profileUpdated: '个人资料已更新',
      profileUpdatedDesc: '您的个人资料已成功保存',
      saveFailed: '保存失败',
      saveFailedDesc: '保存个人资料失败,请重试。',
      changeAvatar: '更换',
      avatarRequirements: '支持 JPG、PNG 或 WebP 格式,最大 5MB。',
      avatarError: '头像错误',
      avatarSizeError: '头像图片大小必须小于 5MB',
      uploadFailed: '上传失败',
      uploadFailedDesc: '头像上传失败,请重试。',
      avatarUpdated: '头像已更新',
      avatarUpdatedDesc: '您的头像已成功更新',
      bindPhone: '绑定',
      bindPhoneTitle: '绑定手机号',
      bindPhoneDesc: '输入您的手机号以接收验证码',
      countryCode: '国家代码',
      phoneNumber: '手机号',
      enterPhoneNumber: '输入手机号',
      verificationCode: '验证码',
      enterCode: '输入验证码',
      sendCode: '发送',
      resend: '重新发送',
      sending: '发送中...',
      binding: '绑定中...',
      confirm: '确认',
      phoneRequired: '手机号不能为空',
      invalidPhone: '手机号格式无效',
      invalidPhoneDesc: '请输入有效的手机号',
      codeSent: '验证码已发送',
      codeSentDesc: '请查看您的手机获取验证码',
      sendCodeFailed: '发送验证码失败',
      sendCodeFailedDesc: '请重试',
      fillAllFields: '请填写所有字段',
      phoneBindSuccess: '手机号绑定成功',
      bindPhoneFailed: '绑定手机号失败',
      bindPhoneFailedDesc: '请重试',
      countries: {
        china: '中国',
        usa: '美国',
        uk: '英国',
        japan: '日本',
        korea: '韩国',
      },
    },
    security: {
      title: '安全',
      password: '密码',
      passwordDesc: '••••••••',
      changePassword: '更改',
      deleteAccount: '删除账户',
      deleteAccountDesc: '永久删除您的账户和所有数据',
      delete: '删除',
      deleteAccountWarning: '此操作无法撤销。您的所有数据将被永久删除。',
      deleteAccountConfirm: '请输入您的邮箱以确认:',
      confirmEmail: '邮箱确认',
      enterEmail: '输入您的邮箱',
      enterPassword: '输入您的密码',
      deleting: '删除中...',
    },
    notifications: {
      title: '通知',
      email: '邮件通知',
      emailDesc: '通过邮件接收通知',
      desktop: '桌面通知',
      desktopDesc: '显示桌面通知',
      marketing: '营销邮件',
      marketingDesc: '接收产品更新和使用技巧',
    },
    preferences: {
      title: '偏好设置',
      language: '语言',
      theme: '主题',
      savePreferences: '保存偏好设置',
      settingsSaved: '设置已保存',
      settingsSavedDesc: '您的偏好设置已成功更新',
      saveFailedDesc: '保存设置失败,请重试。',
      autoSaved: '自动保存',
      languageChanged: '语言已更改',
      languageChangedDesc: '语言设置已更新',
    },
    account: {
      title: '账户',
      changePassword: '更改密码',
      changePasswordDesc: '更新您的账户密码',
      deleteAccount: '删除账户',
      deleteAccountDesc: '永久删除您的账户',
    },
    create: {
      title: '一分钟制作{dynamicText}！',
      makeA: '制作',
      inAMinute: '仅需一分钟！',
      generating: '生成中...',
      promptLoading: '请稍等片刻，您的设计正在创建中...',
      submitPrompt: '生成设计',
      dynamicTexts: {
        Poster: '图文海报',
        Banner: '产品横幅',
        Thumbnail: '视频封面',
        PPT: 'PPT',
        Meme: '表情包',
      },
      dynamicPlaceholders: [
        '设计一个简约的餐厅菜单，突出特色菜品和促销活动...',
        '做一个旅行景点海报。目的地是内蒙古沙漠星空，3天2晚，暑期活动...',
        `设计一张活动海报，分为两个视觉层次：「背景图」和「前景文字排版」。文字排版风格：现代主义风格...`,
        '制作一个声乐课程海报。包含 5 周课程内容，4999 元，讲师介绍（照片）...',
      ],
      library: {
        title: '素材库',
        manage: '管理素材库',
        select: '选择素材库以预览项目',
        selectAll: '全选',
        deselectAll: '取消全选',
        itemCount: '{{selected}}/{{total}}',
        noLibraries: '未找到素材库',
        preview: '预览',
        itemSelected: '已选择项目',
        itemsSelected: '已选择项目',
        addToDesign: '添加到设计',
        clickToSelect: '点击选择',
        removeFromDesign: '从设计中移除',
        dragToCanvas: '拖拽到画布',
        searchPlaceholder: '搜索素材库项目...',
        createNew: '创建新素材库',
        deleteLibrary: '删除素材库',
        editLibrary: '编辑素材库',
        confirmDelete: '确定要删除此素材库吗？',
        libraryDeleted: '素材库已成功删除',
        libraryCreated: '素材库已成功创建',
        libraryUpdated: '素材库已成功更新',
      },
      esmNotSupportedTitle: '浏览器不支持',
      esmNotSupportedDesc: '您的浏览器不支持所需功能。请使用 Chrome、Edge 或 Safari 等现代浏览器。',
      inputRequired: '请输入内容',
      projectCreationFailed: '项目创建失败',
      projectCreationErrorDesc: '创建项目时发生错误，请重试。',
      tryAgain: '重试',
      uploadImage: '参考图片',
      attach: '添加附件',
      attachTips: '添加附件 - 上传参考图片、素材或文档来增强您的设计',
      addMaterial: '添加素材',
      addMaterialTips: '添加图片素材到设计',
      giveInspirationPrompt: '获取灵感',
      dynamicTextOptions: ['海报', '横幅', '迷因'],
      generate: '生成',
      singleMode: '单个',
      batchMode: '批量',
      generateBatch: '批量生成',
      promptPlaceholder: '描述您想要的设计（例如："一个现代咖啡店的海报"）',
      modelLabel: '选择模型：',
      sizeLabel: '选择尺寸：',
      presetTitle: '或选择预设提示：',
      usePrompt: '使用提示词',
      loginRequired: '需要登录',
      loginMessage: '请登录或注册以继续创建设计。',
      loginButton: '登录',
      registerButton: '注册',
      maybeLater: '暂时不了',
      referenceUrl: '阅读链接',
      enterReferenceUrl: '请输入参考链接',
      colorScheme: '配色方案',
      deviceNotSupportedTitle: '暂不支持移动端生成',
      deviceNotSupportedDesc: '为获得最佳体验，请使用电脑访问。当前暂不支持移动设备。',
      multimodal: '多模态',
      whatToCreateToday: '你现在想设计什么？',
      sizes: {
        auto: '自适应',
        height: '高度',
        width: '宽度',
        custom: '自定义',
        wechatMpCover: '微信公众号封面',
        mobilePoster: '手机',
        redNote: '小红书图文',
        newsletter: 'Newsletter',
        infographic: '长图',
        instagram: 'Instagram',
        facebook: 'Facebook',
        twitter: 'X (Twitter)',
        linkedin: 'LinkedIn 帖子',
        pinterest: 'Pinterest',
        youtube: 'YouTube 缩略图',
        tvScreen: '电视屏幕',
        a2: 'A2',
        a3: 'A3',
        a4: 'A4',
        a5: 'A5',
        a2h: 'A2 (横向)',
        a3h: 'A3 (横向)',
        a4h: 'A4 (横向)',
        a5h: 'A5 (横向)',
        businessCard: '名片',
        postcard: '明信片',
        flyer: '传单',
        brochure: '宣传册',
        poster: '海报',
        banner: '横幅',
        billboard: '广告牌',
        menu: '菜单',
        rollUpBanner: '易拉宝 | 80×200cm',
        tableCard10x15: '桌卡 | 10×15cm',
        tableCard15x20: '桌卡 | 15×20cm',
        lightBoxPoster: '灯箱海报 | 60×90cm',
      },
      custom_size: {
        title: '创建自定义尺寸',
        name: '名称（可选）',
        name_placeholder: '我的自定义尺寸',
        width: '宽度（像素）',
        height: '高度（像素）',
        cancel: '取消',
        create: '创建',
      },
      size_categories: {
        social: '社交媒体',
        print: '印刷品与设备',
        aspect: '宽高比',
        custom: '自定义尺寸',
        add_custom: '添加自定义尺寸',
      },
      credits: '积分',
      guide: '获取更多点数',
      projectType: {
        title: '更改项目可见性',
        public: {
          label: '公开',
          description: '任何人都可以查看和二次创作',
          tips: '任何人都可以二次创作此项目。这意味着可以复制并在此基础上编辑。要停用二次创作，请升级后切换到私有。',
        },
        private: {
          label: '私有',
          description: '仅对您自己可见，除非开启分享',
          tag: '专业版',
        },
        upgrade: '升级到专业版',
      },
      mobileWarning: {
        title: '暂不支持移动设备',
        message: '请使用电脑浏览器访问',
        button: '知道了',
      },
      optimizePrompt: {
        title: '提示词智能优化',
        action: '智能提示词优化（适用于少于60个字符的提示词）',
        aiCommunication: '通过AI优化您的设计提示词，获得更精确的结果',
        aiCommunicationShort: 'AI 设计沟通',
        optimize: '优化',
        description: '您的提示词似乎有点简短。是否要使用我们优化后的版本来获得更好的效果？',
        original: '原始提示词：',
        optimized: '优化后的提示词：',
        optimizing: '正在优化提示词...',
        originalDesc: '将作为优化基础的原始输入提示词。',
        optimizedDesc: '您可以编辑由AI生成的优化提示词',
        useOriginal: '使用原始版本',
        useOptimized: '使用优化版本',
      },
      optimizationChat: {
        generateNow: '立即生成',
        title: 'AI 设计需求优化',
        description: '让我们完善您的设计需求以获得最佳效果',
        startPrompt: '您需要哪些特定的设计元素或风格？',
        customInputPlaceholder: '如果你对已有选项不够满意，你还可以在这里输入你的需求...',
        thinking: '处理中...',
        optimizedPromptLabel: '优化后的提示词：',
        submitCustom: '提交',
        continueOptimizing: '继续优化',
        clickToContinue: '点击下方选项继续优化',
        retry: '重试',
        errorGenerating: '内容生成错误',
        errorMessage: '内容生成失败。请重试。',
        finalPromptError: '最终提示词生成失败。',
        conversationError: '无法继续对话。',
        nextQuestionError: '无法生成下一个问题。',
        optimizeError: '无法启动优化对话。',
        useOptimized: '使用优化提示词',
        finalPromptSuccess: '您的设计提示词已优化完成！',
        maxStepsReached: '已达到最大对话步骤',
        designRequirements: '设计需求',
        visualStyle: '视觉风格',
        layoutPreferences: '布局偏好',
        colorScheme: '配色方案',
        typographyChoices: '字体选择',
        additionalNotes: '附加说明',
      },
      insufficientCredits: {
        title: '点数不足',
        description: '您已用完所有点数。邀请好友获取更多点数！',
      },
      generateMode: {
        title: '生成模式',
        fast: '快速模式',
        workflow: '高级模式',
        fastDescription: '单 Agent 模式，生成速度快',
        workflowDescription: '多 Agent 的生成模式，生成速度快，设计质量更高',
      },
      batch: {
        design: '设计',
        designs: '设计',
        generateOne: '生成 1 个设计',
        generateMultiple: '生成 {{count}} 个设计',
        title: '批量生成',
        description: '一次生成多个设计变体，探索不同的创意方向。',
        hint: '更多设计 = 更多创意选择',
      },
      inputRequiredTitle: '需要输入',
      inputRequiredDesc: '请提供文字描述或上传图片以继续。',
      promptTemplateHint: '点击上方的提示词模板快速开始，或输入您自己的创意想法',
      promptTemplates: '提示词模板',
      recentProjects: '我的项目',
      latestTemplates: '最新模板',
      featuredProjects: '精选设计',
      communityFavorites: '社区热门和趋势设计',
      loadingFeatured: '正在加载精选项目...',
      continueWork: '从上次的地方继续',
      featured: '个精选设计',
      readyToUse: '向下滑动查看更多提示词案例，点击即可使用创意提示词',
      viewAll: '查看全部',
      viewMore: '查看更多',
      items: '个项目',
      use: '使用',
      view: '查看',
      open: '打开',
      noRecentProjects: '未找到最近的项目',
      firstDesign: '通过选择模板或使用 AI 生成来创建您的第一个设计',
      noTemplates: '暂无可用模板',
      colorSchemes: {
        defalt: '默认配色方案',
        monochrome: '单色',
        business: '商务专业',
        cafe: '咖啡',
        restaurant: '餐厅',
        vintage: '复古',
        modern: '现代企业',
        nature: '自然',
        luxury: '奢华',
        tech: '科技',
        pastel: '柔和色调',
        retro: '复古风格',
        custom: '自定义颜色',
      },
    },
  },
  token: {
    title: 'API 令牌',
    description: '管理您的 API 令牌以进行程序化访问',
    createNew: '创建新令牌',
    loading: '正在加载令牌...',
    noTokens: '暂无 API 令牌',
    noTokensDescription: '您尚未创建任何 API 令牌。创建一个令牌以程序化访问 API。',
    createFirst: '创建您的第一个令牌',
    name: '名称',
    created: '创建时间',
    key: '密钥',
    lastUsed: '最后使用',
    actions: '操作',
    delete: '删除',
    never: '从未使用',
    securityNotice: '安全提示',
    securityDescription: 'API 令牌可以完全访问您的账户。请确保它们的安全，切勿公开分享。',
    createToken: '创建 API 令牌',
    tokenName: '令牌名称',
    tokenNamePlaceholder: '输入令牌名称',
    tokenNameHelp: '选择一个描述性名称以标识此令牌的用途',
    yourNewToken: '您的新 API 令牌',
    copyWarning: '请立即复制此令牌。您将无法再次查看它！',
    done: '完成',
    cancel: '取消',
    create: '创建令牌',
    nameRequired: '令牌名称为必填项',
    createError: '创建令牌失败',
    deleteSuccess: '令牌删除成功',
    deleteError: '删除令牌失败',
    copySuccess: '令牌已复制到剪贴板',
    copyDescription: '请妥善保管此令牌',
    fetchError: '加载令牌失败',
  },
  inpaint: {
    title: '移除对象',
    description: '涂抹覆盖不需要的对象以将其从图片中移除',
    brushSize: '画笔大小',
    brushSizeTooltip: '按 [ 和 ] 快速调整画笔大小',
    history: '历史记录',
    clear: '清除',
    reset: '重置',
    saveChanges: '保存更改',
    loading: '处理中...',
    progress: '进度',
    zoom: '缩放',
    paintInstructions: '涂抹您想要移除的对象',
    processingTime: '处理时间：{{time}}秒',
    noImageSelected: '未选择图片',
    exportSuccess: '图片导出成功',
    exportError: '导出图片失败',
  },
  projectInfo: {
    page: '页面',
    info: '项目信息',
    name: '名称',
    save: '保存',
    cancel: '取消',
    description: '描述',
    namePlaceholder: '输入项目名称',
    descriptionPlaceholder: '输入项目描述',
    noDescription: '暂无描述',
    public: '公开',
    private: '私有',
    created: '创建时间',
    updated: '更新时间',
  },
  redemption: {
    title: '使用兑换码',
    subtitle: '在下方输入您的兑换代码以向您的账户添加积分',
    seoTitle: '兑换代码 - Seede AI',
    seoDescription: '兑换您的代码以获取 AI 设计生成积分',
    codeLabel: '兑换代码',
    codePlaceholder: '输入您的兑换代码',
    redeemButton: '兑换',
    currentCredits: '当前积分',
    creditsDescription: '积分用于您使用 Seede AI 设计生成',
    helpTitle: '如何使用兑换代码？',
    help1: '在上方字段中输入您的兑换代码',
    help2: '点击"兑换"按钮将积分添加到您的账户',
    help3: '使用您的积分生成精彩的 AI 设计',
    emptyCode: '请输入兑换代码',
    success: '兑换成功！',
    successDescription: '您的福利已添加到您的账户。',
    error: '兑换失败',
    errorDescription: '无效或已过期的兑换代码。',
    alreadyRedeemed: '您已经兑换过此代码。',
    expiredOrLimit: '此兑换代码已过期或已达到使用限制。',
    invalidCode: '无效或未激活的兑换代码。',
    credits: '积分',
    type: {
      credits: '积分',
      subscription: '订阅',
      feature: '功能',
    },
  },
  themeSelector: {
    tooltip: '配色主题',
    default: '智能适配',
    defaultDescription: 'AI 根据内容主题自动适配配色',
    classicBlackWhite: '经典黑白',
    oceanBlue: '海洋蓝',
    sunsetOrange: '夕阳橙',
    forestGreen: '森林绿',
    lavenderPurple: '薰衣草紫',
    rosePink: '玫瑰粉',
    goldenLuxury: '奢华金',
    midnightBlue: '午夜蓝',
    classicBlackWhiteDescription: '经典黑白配色',
    oceanBlueDescription: '清新海洋风格',
    sunsetOrangeDescription: '温暖夕阳色调',
    forestGreenDescription: '自然森林配色',
    lavenderPurpleDescription: '优雅紫色系列',
    rosePinkDescription: '浪漫粉色调',
    goldenLuxuryDescription: '高端金色配色',
    midnightBlueDescription: '深邃夜空配色',
    emeraldLuxury: '翡翠奢华',
    emeraldLuxuryDescription: '奢华翡翠绿色调',
    coralWarm: '珊瑚暖色',
    coralWarmDescription: '充满活力的珊瑚暖色',
    indigoDeep: '靛蓝深邃',
    indigoDeepDescription: '深邃靛蓝的精致感',
    amberWarm: '琥珀暖色',
    amberWarmDescription: '温暖的琥珀光泽',
    tealFresh: '青蓝清新',
    tealFreshDescription: '清新的青蓝活力',
    burgundyElegant: '酒红优雅',
    burgundyElegantDescription: '优雅的酒红丰富感',
    slateModern: '石板现代',
    slateModernDescription: '现代石板的精致感',
    copperVintage: '铜色复古',
    copperVintageDescription: '复古铜色的温暖',
    turquoiseTropical: '绿松石热带',
    turquoiseTropicalDescription: '热带绿松石的清新感',
    plumRich: '梅紫丰富',
    plumRichDescription: '丰富的梅紫优雅',
    sageCalm: '鼠尾草宁静',
    sageCalmDescription: '宁静的鼠尾草清静',
    charcoalSophisticated: '炭灰精致',
    charcoalSophisticatedDescription: '精致的炭灰深度',
    crimsonBold: '深红大胆',
    crimsonBoldDescription: '大胆的深红活力',
    navyProfessional: '海军蓝专业',
    navyProfessionalDescription: '专业的海军蓝自信',
    mintFresh: '薄荷清新',
    mintFreshDescription: '清新的薄荷凉爽',
    bronzeClassic: '青铜经典',
    bronzeClassicDescription: '经典的青铜优雅',
    steelIndustrial: '钢灰工业',
    steelIndustrialDescription: '工业钢灰的力量感',
    ivoryElegant: '象牙优雅',
    ivoryElegantDescription: '优雅的象牙精致感',
    mahoganyRich: '红木丰富',
    mahoganyRichDescription: '丰富的红木温暖',
    addCustomTheme: '添加自定义主题',
    hoverToPreview: '鼠标悬停预览配色',
    primaryColor: '主色',
    secondaryColor: '辅助色',
    deleteCustomTheme: '删除自定义主题',
    createCustomTheme: '创建自定义主题',
    createThemeDesc: '设计专属的配色方案',
    themeName: '主题名称',
    themeDescription: '主题描述',
    themeNamePlaceholder: '我的主题',
    themeDescriptionPlaceholder: '输入主题描述',
    colorScheme: '配色方案',
    smartColorExtraction: '智能配色提取',
    uploadImage: '上传图片提取配色',
    supportedFormats: '支持 JPG、PNG 格式，最大 5MB',
    replaceImage: '更换',
    extractingColors: '正在提取配色...',
    customColors: '自定义配色',
    primaryColorLabel: '主色调',
    secondaryColorLabel: '辅助色',
    color3Label: '背景色',
    color4Label: '边框色',
    preview: '预览效果',
    themePreview: '主题预览',
    cancel: '取消',
    saveTheme: '保存主题',
    copied: '已复制！',
    pleaseSelectImage: '请选择一个图片文件',
    imageSizeLimit: '图片大小不能超过 5MB',
    colorExtractionFailed: '配色提取失败，请重试',
    imageLoadFailed: '图片加载失败，请重试',
    imageProcessFailed: '图片处理失败，请重试',
    cardExample: '卡片示例',
    cardExampleDesc: '这是使用您配色方案的卡片效果',
  },
  credits: {
    balance: '积分余额',
    remaining: '剩余 {{count}} 积分',
    remainingCredits: '剩余积分',
    inviteFriends: '邀请好友',
    inviteReward: '邀请好友注册即可获得积分奖励',
    recharge: '充值积分',
    rechargeDesc: '购买积分套餐，享受更多设计功能',
    rechargeNow: '立即充值',
    exhausted: '积分已用完，请充值后继续使用。',
  },
  attach: {
    addAttachment: '添加附件',
    addReferenceImage: '你要参考的设计',
    uploadImageMaterial: '设计里所需要的素材',
    uploading: '上传中...',
    supportedFormats: '支持 PNG、JPG、JPEG、WEBP 格式',
    selectMaterial: '选择素材',
    failedToLoadAssets: '加载素材失败',
    material: '素材',
    remove: '移除',
    asUsage: '作为{{usage}}',
    defaultUsage: '素材',
    parsing: '解析中...',
    Category: {
      recommended: '推荐',
      businessMarketing: '商业营销',
      creativeArt: '创意艺术',
    },
    referenceImage: '参考图片',
    materialLibrary: '素材',
    documents: '文档',
    addDocuments: '上传文档，一键图文排版',
    supportedDocumentFormats: '支持 DOCX、PDF、TXT、MD 格式（最大 15MB）',
    dragAndDropFiles: '拖拽文件到此处',
    or: '或',
    browseFiles: '浏览文件',
    uploadSuccessful: '上传成功',
    uploadFailed: '上传失败',
    fileTooBig: '文件大小超过 10MB 限制',
    unsupportedFormat: '不支持的文件格式',
    multipleFilesSupported: '支持多文件上传',
    attachmentManager: '附件管理器',
    noAttachments: '暂无附件',
    attachments: '附件',
  },
  material: {
    selectUsage: '选择用途',
    singleSelect: '（单选）',
    background: '背景',
    product: '产品',
    model: '模特',
    logo: 'Logo',
    qrcode: '二维码',
    icon: '图标',
    decoration: '装饰',
    texture: '纹理',
    chart: '图表',
    customUsagePlaceholder: '自定义用途',
    add: '添加',
  },
  attachTag: {
    editReferenceFeatures: '编辑参考特征',
    selectReferencePoints: '参考要素',
    multipleSelection: '（多选）',
    referencePoints: {
      all: '全部',
      layout: '布局',
      style: '风格',
      color: '颜色',
      texture: '质感',
      copy: '文案',
      font: '字体',
    },
  },
  materialList: {
    viewMore: '查看更多',
    selectUsage: '选择用途',
    selectedMaterials: '已选素材',
    noSelectedMaterials: '未选择素材',
    recentlyUploadedMaterials: '最近上传的素材',
    failedToLoadAssets: '加载素材失败',
    noMaterials: '暂无素材',
    uploadMaterialsToUse: '上传素材以在设计中使用',
  },
  fillPanel: {
    color: '纯色',
    solid: '纯色',
    gradient: '渐变',
    dynamic: '动态效果',
    image: '图片',
    search: '搜索',
    uploadImage: '上传图片',
    gradientDirection: '渐变方向',
    documentColors: '文档颜色',
  },
  assetUpload: {
    uploadImage: '上传图片',
    dragDropOrClick: '拖拽图片到此处，或点击浏览',
    chooseFile: '选择文件',
    uploadingImage: '正在上传图片...',
    supportedFormats: 'JPG, PNG, WebP, SVG',
  },
  iconLibrary: {
    iconLibrary: '图标库',
    chooseFrom: '选择自',
    icons: '个图标',
    searchIcons: '搜索图标...',
    allIcons: '全部图标',
    noIconsFound: '未找到图标',
    tryDifferentKeywords: '尝试不同的关键词或选择其他分类',
    showAllIcons: '显示全部图标',
    loadingIconSets: '加载图标集中...',
  },
  qrcodePanel: {
    qrCodeGenerator: '二维码生成器',
    colorPresets: '预设配色',
    createCustomQrCodes: '为您的设计创建自定义二维码',
    content: '内容',
    enterUrlOrText: '输入链接或文本...',
    styleSettings: '样式设置',
    margin: '边距',
    foreground: '前景色',
    background: '背景色',
    generating: '生成中...',
    generateQrCode: '生成二维码',
    addToDesign: '添加到设计',
    createQrCode: '创建二维码',
    enterContentAndCustomize: '输入您的内容并自定义样式以生成精美的二维码',
  },
  imagePanel: {
    imageTypes: '图片类型',
    unsplash: '搜索图片',
    highQualityImages: '高质量图片素材库',
    icon: '图标库',
    beautifulIcons: '选择精美图标',
    qr: '二维码',
    generate: 'AI 生成',
    generateImage: '使用 AI 生成图片',
    generateQrCode: '生成二维码',
    selectImageType: '选择图片类型',
    browse: '浏览',
    search: '搜索',
    upload: '上传',
    illustration: '插画',
    illustrationDesc: '为您的设计提供精美插画',
  },
  quickQrCode: {
    editQrCode: '编辑二维码',
    qrCodeEditor: '二维码编辑器',
    typeSelection: '类型选择',
    content: '内容',
    generating: '生成中...',
    generateQrCode: '生成二维码',
    dragToAdd: '拖拽添加到画布',
    advancedSettings: '高级设置',
    foregroundColor: '前景色',
    backgroundColor: '背景色',
    margin: '边距',
    size: '尺寸',
    download: '下载',
    preview: '预览',
    enterContentToGenerate: '输入内容以生成二维码',
    selectImageFirst: '请先选择一张图片',
    types: {
      text: '文本',
      url: '链接',
      email: '邮箱',
      phone: '电话',
      wifi: 'WiFi',
      contact: '联系人',
    },
    placeholders: {
      text: '输入任意文本',
      url: 'https://example.com',
      email: 'user@example.com',
      phone: '+1 555 123 4567',
      wifi: 'WiFi名称;密码;加密类型',
      contact: '姓名;电话;邮箱',
    },
    generateFailed: '生成二维码失败',
    tips: {
      dragToCanvas: '将二维码拖拽到画布上添加',
      selectImageNode: '选择图片节点以替换为二维码',
      adjustSettings: '调整边距和颜色以自定义外观',
    },
  },
  chatContent: {
    referenceImages: '参考图片',
    documents: '文档',
    colorScheme: '配色方案',
    materialFiles: '素材文件',
    libraryItems: '组件库',
    designLibrary: '设计库',
    material: '素材',
    style: '风格',
  },
  modelSelector: {
    selectModel: '选择模型',
    recommendedModels: '推荐模型',
    allModels: '所有模型',
    exploreMore: '探索更多模型',
    additionalModels: '更多模型可用',
    otherModels: '其他模型',
    showLess: '显示更少',
    mostPopular: '最受欢迎',
    multimodal: '支持图像输入',
    limitedTimeFree: '限时免费',
    new: '上新',
    promoDefault: 'Gemini 3 Pro 全新上线',
    promoGemini: '就是它，快来试试吧',
  },
  browserCompatibility: {
    error: {
      title: '浏览器兼容性错误',
      description: '您的浏览器不支持所需功能。',
      checkDetails: '查看兼容性详情',
    },
    checkDetails: '查看浏览器兼容性详情',
  },
  textEffect: {
    title: '文字效果',
    description: '选择预设样式',
    clearEffects: '清除效果',
  },
  nodeTypes: {
    text: '文本',
    image: '图片',
    shape: '形状',
    line: '线条',
    path: '路径',
    col: '列',
    row: '行',
    group: '组合',
    frame: '框架',
    video: '视频',
  },
  shapeTypes: {
    rect: '矩形',
    ellipse: '椭圆',
    triangle: '三角形',
    star: '星形',
    polygon: '多边形',
    hexagon: '六边形',
    octagon: '八边形',
    pentagon: '五边形',
    cross: '十字',
    heart: '心形',
  },
  browser: {
    title: '浏览器兼容性',
    description: '检查您的浏览器与 Seede AI 功能的兼容性',
    overallStatus: '总体状态',
    browserInfo: '浏览器信息',
    featureDetails: '功能详情',
    status: '状态',
    retest: '重新测试',
    testing: '测试中...',
    analyzing: '分析兼容性中...',
    checkComplete: '兼容性检查完成',
    checkCompleteDesc: '浏览器兼容性分析成功完成。',
    checkFailed: '检查失败',
    checkFailedDesc: '运行兼容性检查失败。',
    recommendChrome: '推荐浏览器：Chrome',
    recommendChromeDesc:
      '为了获得最佳的 Seede AI 体验，我们强烈建议使用最新版本的 Google Chrome 浏览器。',
    downloadChrome: '下载 Chrome',
    statuses: {
      fullyCompatible: '完全兼容',
      compatibleWithWarnings: '兼容但有警告',
      incompatible: '不兼容',
      unknown: '未知',
      supported: '支持',
      notSupported: '不支持',
    },
    categories: {
      required: '必需',
      optional: '可选',
      compatible: '兼容',
      browser: '浏览器',
      version: '版本',
      engine: '引擎',
    },
    results: {
      pass: '通过',
      fail: '失败',
      warn: '警告',
      yes: '是',
      no: '否',
    },
    issues: {
      criticalTitle: '严重问题',
      criticalDesc: '请更新您的浏览器以确保 Seede AI 兼容性。',
      performanceTitle: '性能警告',
      performanceDesc: '某些功能的性能可能会降低。',
      excellentTitle: '优秀',
      excellentDesc: '与所有 Seede AI 功能完全兼容。',
    },
  },
  announcement: {
    title: '产品公告',
    description: '查看来自 Seede AI 的最新产品更新、功能发布和重要公告',
    keywords: '产品公告,更新日志,功能发布,Seede AI',
    pageTitle: '产品公告',
    pageDescription: '探索最新功能和产品进展',
    loading: '加载中...',
    noAnnouncements: '暂无公告',
    noAnnouncementsDesc: '等待新消息',
    subscribeTitle: '订阅更新',
    subscribeDesc: '第一时间获取重要更新通知',
    subscribeButton: '立即订阅',
    error: '错误',
    loadError: '加载公告失败，请稍后重试。',
    types: {
      feature: '功能',
      improvement: '改进',
      promotion: '推广',
    },
    priorities: {
      high: '高',
      medium: '中',
      low: '低',
    },
    tags: {
      modelUpdate: '模型更新',
      ai: 'AI',
      reasoningModel: '推理模型',
      newFeature: '新功能',
      uiOptimization: '界面优化',
      userExperience: '用户体验',
      performanceOptimization: '性能优化',
      systemUpgrade: '系统升级',
      promotion: '推广',
      discount: '折扣',
    },
  },
  imageGeneratePanel: {
    title: 'AI 图像生成',
    subtitle: '用创意文字创造无限可能',
    history: '历史记录',
    styleSection: '艺术风格',
    aiEnhanceTitle: 'AI 智能增强',
    aiEnhanceDesc: '自动翻译并优化您的创意描述',
    promptPlaceholder: '描述您心中的画面，让 AI 为您呈现艺术之美...',
    selectModel: '选择模型',
    startCreate: '开始创作',
    resultTitle: '生成结果',
    creating: '创作中...',
    createDone: '创作完成',
    optimizingPrompt: '正在优化您的创意描述...',
    creatingImage: '正在精心创作您的图像...',
    pleaseWait: '请稍候，艺术正在诞生',
    selectArtwork: '选择作品',
    generatedArtworkAlt: '生成的艺术作品',
    generationFailed: '生成失败',
    retry: '重试',
    styleTitle: '风格选择',
    error: {
      emptyPrompt: '请输入创意描述',
      generationFailedTitle: '生成失败',
      generationFailed: '图像生成失败，请重试',
    },
    styles: {
      default: '默认',
      defaultDesc: '自然风格',
      cartoon: '卡通',
      cartoonDesc: '可爱卡通风格',
      photorealistic: '写实',
      photorealisticDesc: '逼真写实风格',
      render3d: '3D 渲染',
      render3dDesc: '精美 3D 效果',
      oilPainting: '油画',
      oilPaintingDesc: '经典油画质感',
      watercolor: '水彩',
      watercolorDesc: '清新水彩风格',
      cyberpunk: '赛博朋克',
      cyberpunkDesc: '未来科幻风格',
      minimalist: '极简',
      minimalistDesc: '简约现代风格',
    },
  },
  imageSearchPanel: {
    title: '图像搜索',
    subtitle: '为您寻找完美素材',
    searchPlaceholder: '描述您需要的图像，智能为您匹配...',
    recommendedCategories: '推荐分类',
    smartSuggestions: '智能建议',
    searchResults: '搜索结果',
    backToSearch: '返回搜索',
    resultsShown: '张图片',
    searching: 'AI 正在为您搜索...',
    importing: '导入中...',
    use: '使用',
    loadMore: '加载更多',
    loadingMore: '正在加载更多图片...',
    noResults: '未找到相关图片',
    tryDifferentKeywords: '尝试使用不同的关键词',
    searchAgain: '重新搜索',
    allResultsShown: '所有结果已显示',
    categories: {
      landscape: '风景',
      landscapeDesc: '自然风光',
      abstract: '抽象',
      abstractDesc: '抽象艺术',
      business: '商务',
      businessDesc: '商务风格',
      technology: '科技',
      technologyDesc: '科技感',
      lifestyle: '生活',
      lifestyleDesc: '生活场景',
      creative: '创意',
      creativeDesc: '创意设计',
    },
    suggestions: {
      hdWallpaper: '高清壁纸背景',
      productDisplay: '产品展示图',
      socialMedia: '社交媒体素材',
      presentation: '演示文稿背景',
      webBanner: '网站横幅图片',
    },
  },
  transformPanel: {
    title: '变换',
    presets: '预设',
    parameters: '自定义',
    reset: '重置',
    mixed: '混合',
    matrix: {
      identity: '原始',
      identityDesc: '无变换',
      flipX: '水平翻转',
      flipXDesc: '水平翻转',
      flipY: '垂直翻转',
      flipYDesc: '垂直翻转',
      rotate90: '旋转 90°',
      rotate90Desc: '旋转 90 度',
      rotate180: '旋转 180°',
      rotate180Desc: '旋转 180 度',
      rotate270: '旋转 270°',
      rotate270Desc: '旋转 270 度',
      skewX: '水平倾斜',
      skewXDesc: '水平倾斜',
      skewY: '垂直倾斜',
      skewYDesc: '垂直倾斜',
      scaleUp: '放大',
      scaleUpDesc: '放大 20%',
      scaleDown: '缩小',
      scaleDownDesc: '缩小 20%',
    },
  },
  imageEditor: {
    title: '图片编辑器',
    aspectRatio: '宽高比',
    loading: '加载中...',
    reset: '重置',
    saveChanges: '保存更改',
  },
  gradientPicker: {
    preview: '预览',
    type: '类型',
    angle: '角度',
    colorStops: '颜色节点',
    addStop: '添加节点',
    color: '颜色',
    colorValue: '颜色值',
    position: '位置',
    linear: '线性',
    radial: '径向',
  },
  save: {
    saving: '保存中...',
    saved: '已保存',
    error: '保存失败',
    unsaved: '未保存的更改',
  },
  shapePanel: {
    shape: '形状',
    selectShape: '选择形状',
    changeShapeDesc: '为选中的元素更改形状',
    rectangle: '矩形',
    triangle: '三角形',
    circle: '圆形',
  },
  borderPanel: {
    border: '边框',
    customizeBorder: '自定义边框颜色和宽度',
  },
  clipPathPanel: {
    clipPath: '裁剪路径',
    none: '默认',
    triangle: '三角形',
    parallelogram: '平行四边形',
    leftTiltedParallelogram: '左倾平行四边形',
    trapezoid: '梯形',
    star: '星形',
    pentagon: '五边形',
    hexagon: '六边形',
    octagon: '八边形',
    circle: '圆形',
    selectClipPath: '选择裁剪路径',
    applyClipPath: '为选中的元素应用裁剪路径',
  },
  chatPanel: {
    local: '局部',
    global: '全局',
    localEdit: '局部编辑：',
    localEditDesc: '仅编辑当前选中的元素，保持其他内容不变',
    globalEdit: '全局编辑：',
    globalEditDesc: '可以对整个页面进行修改和重新布局',
  },
  recentAssetPanel: {
    all: '全部',
    favorites: '收藏',
    noFavoriteAssets: '暂无收藏素材',
    noRecentAssets: '暂无最近使用的素材',
    favoriteAssetsWillAppearHere: '您收藏的素材将显示在这里',
    recentlyUsedAssetsWillAppearHere: '您最近使用的素材将显示在这里',
    today: '今天',
    yesterday: '昨天',
    removeFromFavorites: '取消收藏',
    addToFavorites: '添加到收藏夹',
  },
  frameMenu: {
    lockPage: '锁定页面',
    unlockPage: '解锁页面',
    duplicatePage: '复制页面',
    moreOptions: '更多选项',
    moreActions: '更多操作',
    moveToTop: '置于顶层',
    moveUp: '向上移动',
    moveDown: '向下移动',
    moveToBottom: '置于底层',
    deletePage: '删除页面',
  },
  textFillMode: {
    default: '默认',
    char: '字符',
    line: '行',
  },
  shaderEditor: {
    shaderEffects: '动态效果',
    effectType: '类型',
    presets: '预设',
    preset: '预设',
    enableAnimation: '启用动画',
    disableAnimation: '禁用动画',
    generateRandomSeed: '生成随机种子',
    resetParameters: '重置参数',
    moreSettings: '更多设置',
    shaderEditorDisabled: '着色器编辑器已禁用',
    addColor: '添加',
    seed: '种子',
    speed: '速度',
    animated: '动画',
  },
  imageMenu: {
    aiImage: 'AI 图像',
    icons: '图标',
    QRCode: '二维码',
    title: 'AI 图像编辑器',
    description: '使用 AI 编辑您的图像',
    modelOptions: {
      gemini: 'Gemini',
      openai: 'GPT-4o',
      comingSoon: '即将推出',
    },
    placeholder: '描述您想要的图像修改...',
    generate: '编辑图像',
    loading: '生成中...',
    editImage: 'AI 图像编辑',
    selectModel: '选择模型',
  },
  iconMenu: {
    iconLibrary: '图标库',
    searchIcons: '搜索图标...',
    allIcons: '所有图标',
    noIconsFound: '未找到图标',
    iconsAvailable: '个图标可用',
    loadingIcons: '加载图标中...',
    selectIconSet: '选择图标集',
    categories: {
      all: '全部',
      general: '通用',
      arrows: '箭头',
      arrow: '箭头',
      media: '媒体',
      ui: '界面',
      business: '商务',
      technology: '科技',
      social: '社交',
      travel: '旅行',
      food: '食物',
      weather: '天气',
      sports: '体育',
      medical: '医疗',
      education: '教育',
      shopping: '购物',
      communication: '通信',
      design: '设计',
      finance: '金融',
      security: '安全',
      entertainment: '娱乐',
      file: '文件',
      alert: '警告',
      health: '健康',
      tools: '工具',
      people: '人物',
    },
  },
  unsplashPanel: {
    title: '图片',
    description: '使用高质量的视觉素材',
    searchPlaceholder: '搜索精美图片...',
    searchButton: '搜索',
    loadingImages: '正在寻找精美图片...',
    loadMore: '加载更多',
    loading: '加载中...',
    noImages: '无图片',
    noImagesDescription: '尝试调整您的搜索关键词',
    browseSelected: '浏览选中的图片',
    use: '使用',
    emptyState: {
      title: '未找到图片',
      description: '尝试调整您的搜索关键词',
    },
    presets: {
      featured: '精选',
      nature: '自然',
      abstract: '抽象',
      texture: '纹理',
      gradient: '渐变',
    },
  },
  quickEditMenu: {
    placeholder: '输入需求，快速编辑...',
    loading: '处理中...',
    send: '发送',
    error: '处理请求失败',
    presets: {
      aiQuickPresets: 'AI 快速预设',
      textEditing: '文本编辑',
      imageProcessing: '图像处理',
      shapeEffects: '形状效果',
      rewrite: '重写',
      refine: '精炼',
      professional: '专业化',
      brand: '品牌语调',
      concise: '简洁',
      translate: '翻译',
      correct: '纠正',
      expand: '扩展',
      summary: '总结',
    },
    prompts: {
      rewrite: '重写这段文本，保持原意但使用不同的表达方式',
      refine: '精炼这段文本，去除冗余并保留核心信息',
      professional: '用更专业的语调重写文本',
      brand: '重写文本使其更具品牌特色',
      concise: '重写文本使其更加简洁',
      translate: '将文本翻译成另一种语言（中文到英文，英文到中文）',
      correct: '检查并纠正文本中的语法和拼写错误',
      expand: '扩展这段文本，添加更多细节和内容',
      summary: '生成这段文本的简洁摘要',
    },
  },
  textAlign: {
    left: '左对齐',
    center: '居中对齐',
    right: '右对齐',
  },
  helpCenter: {
    title: '帮助中心',
    description: '掌握 Seede Design 所需的一切',
    tabs: {
      shortcuts: '快捷键',
      features: '功能',
      tips: '技巧',
    },
    shortcuts: {
      essential: {
        title: '基础操作',
        undo: '撤销上一步操作',
        redo: '重做上一步操作',
        copy: '复制选中元素',
        paste: '粘贴元素',
        delete: '删除选中元素',
        save: '保存项目',
      },
      selection: {
        title: '选择和图层',
        selectAll: '选择所有元素',
        group: '组合选中元素',
        ungroup: '解除组合选中元素',
        duplicate: '复制选中元素',
        bringToFront: '置于顶层',
        sendToBack: '置于底层',
      },
      view: {
        title: '视图和导航',
        zoomToFit: '缩放到适应画布',
        zoomIn: '放大',
        zoomOut: '缩小',
        resetZoom: '重置缩放到 100%',
        pan: '平移画布（按住并拖拽）',
      },
      text: {
        title: '文本编辑',
        bold: '粗体文本',
        italic: '斜体文本',
        underline: '下划线文本',
        increaseFontSize: '增大字体大小',
        decreaseFontSize: '减小字体大小',
      },
      help: {
        title: '帮助和界面',
        openHelp: '打开此帮助面板',
        closeDialogs: '关闭对话框或取消选择',
      },
    },
    features: {
      aiAssistant: {
        title: '智能 AI 助手',
        description: '与 AI 聊天生成设计、修改元素并获取创意建议',
        tips: ['请求具体的设计更改', '要求配色方案建议', '获取布局推荐'],
      },
      textTools: {
        title: '高级文本工具',
        description: '富文本编辑，支持丰富字体、效果和版式控制',
        tips: ['选择最匹配设计的字体', '使用文本效果和阴影', '应用渐变文本填充'],
      },
      imageProcessing: {
        title: '图像处理',
        description: '内置图像编辑、背景移除和滤镜效果',
        tips: ['自动移除背景', '应用艺术滤镜', '调整亮度和对比度'],
      },
      export: {
        title: '导出选项',
        description: '多格式导出：PNG、JPG、PDF，支持自定义尺寸',
        tips: ['为您的使用场景选择最佳格式', '设置自定义导出尺寸', '批量导出多个设计'],
      },
      collaboration: {
        title: '协作',
        description: '分享设计、协作并管理项目权限',
        tips: ['通过链接分享', '设置查看/编辑权限', '多版本历史'],
      },
    },
    tips: {
      gettingStarted: {
        title: '入门指南',
        items: [
          '从模板开始并自定义以节省时间',
          '使用 AI 聊天描述您想要创建的内容',
          '直接拖拽图片到画布上',
          '双击文本元素快速编辑',
        ],
      },
      design: {
        title: '设计最佳实践',
        items: [
          '保持元素间距一致',
          '使用有限的配色方案确保设计连贯',
          '选择相互补充的字体',
          '确保重要文本具有良好的对比度以保持可读性',
        ],
      },
      productivity: {
        title: '效率提升技巧',
        items: [
          '使用键盘快捷键提高工作流程效率',
          '组合相关元素便于管理',
          '将常用元素保存为组件',
          '使用网格和对齐工具确保精确',
        ],
      },
      advanced: {
        title: '高级技巧',
        items: [
          '叠加多种效果营造丰富的视觉层次',
          '使用蒙版创建复杂的合成效果',
          '尝试混合模式获得独特效果',
          '为背景创建自定义颜色渐变',
        ],
      },
    },
    footer: {
      helpShortcut: '打开此帮助',
      documentation: '需要更多帮助？访问我们的文档',
    },
  },
  createAssetPicker: {
    historyTitle: '历史记录',
    viewAll: '查看全部',
    materialLibrary: '素材库',
    materialLibraryDesc: '选择素材添加到您的创作中',
    loading: '加载中...',
    loadingMaterials: '正在加载素材...',
    error: '加载失败',
    noMaterials: '暂无素材',
    noMaterialsDesc: '暂无可用素材，上传的项目将在此处显示',
    showingAll: '已显示所有素材',
    retryLoad: '重试加载',
  },
  layerTree: {
    title: '图层',
    searchPlaceholder: '搜索图层...',
    showOnlyMatches: '仅显示匹配项',
    multiSelectMode: '多选模式',
    density: {
      standard: '标准',
      compact: '紧凑',
    },
    actions: {
      toggleLock: '切换锁定',
      toggleVisibility: '切换可见性',
      bringForward: '向前移动',
      sendBackward: '向后移动',
      expand: '展开',
      collapse: '折叠',
      dragToReorder: '拖拽重新排序',
      hideLayer: '隐藏图层',
      showLayer: '显示图层',
      lockLayer: '锁定图层',
      unlockLayer: '解锁图层',
    },
    contextMenu: {
      rename: '重命名',
      duplicate: '复制',
      delete: '删除',
      group: '组合',
      ungroup: '取消组合',
      bringToFront: '置于顶层',
      sendToBack: '置于底层',
    },
    messages: {
      cannotMoveToDescendant: '无法将图层移动到其自身的子层中。',
      confirmCrossFrameMove: '跨框架移动图层可能会影响布局。是否继续？',
      moveConfirm: '移动',
      moveCancel: '取消',
    },
    palette: {
      searchPlaceholder: '搜索操作...',
      noResults: '未找到匹配的操作',
    },
    shortcuts: {
      multiSelect: '按住 Cmd/Ctrl 进行多选',
      rangeSelect: '按住 Shift 进行范围选择',
      toggleExpand: '双击展开/折叠',
    },
    dropActions: {
      parentLocked: '父级被锁定，无法拖入。',
      parentHidden: '父级不可见，无法拖入。',
    },
  },
  strokePanel: {
    stroke: '描边',
    border: '边框',
    customizeBorder: '自定义边框样式',
    quickStyles: '快速样式',
    color: '颜色',
    width: '宽度',
    dash: '虚线',
    dashPattern: '虚线图案',
    lineCap: '线端样式',
    lineJoin: '线条连接',
    miterLimit: '斜接限制',
    presets: {
      none: '无',
      thin: '细',
      medium: '中等',
      thick: '粗',
      dashed: '虚线',
      dotted: '点线',
    },
    lineCaps: {
      butt: '平端',
      round: '圆端',
      square: '方端',
    },
    lineJoins: {
      miter: '斜接',
      round: '圆角',
      bevel: '斜角',
    },
    placeholders: {
      dashPattern: '例如：5,5 或 10,5,3,5',
      selectLineCap: '选择线端样式',
      selectLineJoin: '选择线条连接',
      mixed: '混合',
    },
  },
  editPanel: {
    searchPlaceholder: '按名称、文本或类型搜索元素...',
    clearSearch: '清除搜索',
    locateElement: '定位元素',
    noEditableElements: '无可编辑元素',
    elementsWillAppear: '可用时元素将显示在这里',
    noMatchingElements: '无匹配元素',
    adjustSearchTerms: '尝试调整搜索条件或清除搜索以查看所有元素',
    noFramesFound: '未找到框架',
    importDesignFile: '导入设计文件以开始编辑内容',
    enterText: '输入文本...',
    uploadImage: '上传图片',
    element: '元素',
    frame: '框架',
  },
  workspaceAsset: {
    all: '全部',
    favorites: '收藏',
    recent: '最近上传',
    ai: 'AI 生成',
    searchAssets: '搜索资源...',
    upload: '上传',
    select: '选择',
    cancel: '取消',
    selectedCount: '已选择 {{count}} 个',
    selectAll: '全选',
    clearSelection: '清除选择',
    delete: '删除',
    confirmBatchDelete: '确定要删除 {{count}} 个资源吗？此操作无法撤销。',
    loadingAssets: '加载资源中...',
    emptyTitle: '您的资源库为空',
    emptyDescription: '上传您的第一个资源，开始构建创意媒体收藏',
    uploadAsset: '上传资源',
    loadingMore: '加载更多...',
    noSearchResults: '没有找到匹配的资源',
    noSearchResultsDescription: '没有找到与“{{query}}”匹配的资源，试试其他关键词或上传新的资源',
    somethingWentWrong: '出现问题',
    tryAgain: '重试',
    uploadFailed: '上传失败',
  },
  pageListPanel: {
    pages: '页面',
    addPage: '添加页面',
    duplicatePage: '复制页面',
    deletePage: '删除页面',
    pageActions: '页面操作',
    page: '页面',
  },
  filterPanel: {
    filter: '滤镜',
    presets: '预设',
    custom: '自定义',
    filterType: '滤镜类型',
    intensity: '强度',
    filterValue: '滤镜值',
    none: '无',
    grayscale: '灰度',
    sepia: '复古',
    blur: '模糊',
    brightness: '亮度',
    contrast: '对比度',
    invert: '反色',
    saturate: '饱和度',
    placeholder: '例如：blur(5px) brightness(120%)',
  },
  about: {
    title: '关于我们',
    subtitle: '每个人心中都埋藏着一颗创意的种子，它应当被呵护、发芽、绽放',
    vision: {
      title: 'Vision',
      content: [
        '我们相信，AI 将重新定义创作的边界。未来，每个人都能够通过简单的对话，将脑海中的想法瞬间转化为精美的视觉作品。',
        'Seede AI 致力于成为连接想象力与现实的桥梁，让设计不再是少数人的专属技能，而是人人都能掌握的创意工具。',
      ],
    },
    mission: {
      title: 'Mission',
      content: [
        '降低设计门槛，让每个人都能轻松创作出专业级的视觉内容。',
        '通过持续优化 AI 模型和用户体验，为用户提供更智能、更高效、更具创造力的设计解决方案。',
        '构建一个开放、友好的创作社区，让灵感在这里碰撞、成长。',
      ],
    },
    values: {
      title: 'Values',
      content: [
        '创新至上：我们相信技术的力量，始终追求创新与突破。',
        '用户为本：倾听用户需求，为每一次创作体验负责。',
        '简洁高效：复杂的技术，简单的体验，让创作回归本质。',
        '开放共享：我们欢迎每一位创作者，共同探索设计的无限可能。',
      ],
    },
    story: {
      title: 'Story',
      content: [
        '我是 Longyi，Seede AI 的创始人。很多人问我，为什么会选择做 AI 设计工具。我的故事，或许和很多人想象的不太一样。',
        '我从小就对"创造"有着深深的执念。高中时，我曾独自搭建并维护了一个本地论坛——"德阳论坛"。那时我并不太懂技术，只掌握一些基础的 PHP，但当我看到用户真正在使用我做的产品，甚至有人误以为那是"官方运营"的时候，那种成就感让我第一次感受到技术背后"人"的温度。',
        '大学我选择了网络安全，也获得过一些奖项，但逐渐发现，我真正热爱的并非"破解与防御"，而是"从零开始做出东西"。于是大二那年，我选择离开校园，进入真正的行业中去学习与成长。',
        '在美团期间，深受 Serverless 理念和 Vercel 的启发，我从零开始独立设计并实现了一个迷你版的 Vercel 系统。那是我第一次真正从纯粹的技术架构，转向以产品思维构建解决方案。这段经历让我深刻意识到：技术本身不是终点，为用户创造流畅、高效的体验才是核心。',
        '离开美团后，我加入了初创公司 Dora AI，正式踏入设计工具这一领域。我投入大量时间深入研究 Figma 和 Canva，不仅是作为用户，更是以产品构建者的视角，去理解现代设计工具背后的架构逻辑、交互理念与实现路径。那是我第一次系统性地认识到，设计工具的本质是帮助人们更自由地表达想法，而技术，应当服务于这个目标。ChatGPT 发布之后，我更加确信：AI 必将重塑设计的未来。',
        '于是，Seede AI 诞生了。"Seede"这个名字，源于"Seed"与"Design"的结合。我们相信，每个人心中都埋藏着一颗创意的种子，它应当被呵护、发芽、绽放——而不应被复杂的技术和工具所阻碍。',
        '如今，Seede AI 正致力于打造这样一款产品：你无需任何设计基础，只需输入你的想法，AI 就能帮你生成美观且实用的图片、海报、邀请函、信息图……尤其在文字与信息设计领域，我们持续优化排版的控制力与视觉效果，希望让每一位用户都能轻松自如地表达自我。',
        '对我而言，技术从来不只是代码和模型，它更是一座通往人文的桥梁。我们仍处于早期阶段，还有很多需要完善的地方，但我始终坚信：真正的技术，应当让人变得更自由、更自信、更富有创造力。',
        '期待在未来，与你共同打造一个更加智能和开放的设计世界。—— Longyi, Seede AI 创始人',
      ],
    },
  },
  order: {
    title: '订单',
    loadingOrders: '加载订单中...',
    noOrdersFound: '未找到订单',
    failedToLoadOrders: '加载订单失败',
    noMoreOrders: '没有更多订单',
    id: '订单号',
    date: '日期',
    details: '详情',
    amount: '金额',
    status: '状态',
    paymentMethod: {
      alipay: '支付宝',
      wxpay: '微信支付',
      gift: '礼品',
      creditCard: '信用卡',
      payment: '支付',
    },
    statusLabels: {
      succeeded: '成功',
      paid: '已支付',
      complete: '已完成',
      pending: '待处理',
      processing: '处理中',
      failed: '失败',
      cancelled: '已取消',
    },
  },
};
